export const pl: Record<string, string> = {
  'Read-only view': 'Widok tylko do odczytu',
  'Viewing as client · read-only': 'Podgląd jako klient · tylko do odczytu',
  Exit: 'Wyjdź',
  'Open menu': 'Otwórz menu',
  'Client calendar opened in read-only preview': 'Kalendarz klienta otwarty w trybie podglądu',
  'AMY will prepare a different idea for this slot': 'AMY przygotuje inny pomysł na to miejsce',
  'Slot left intentionally empty': 'Miejsce celowo zostawione puste',
  'Comment saved': 'Komentarz zapisany',
  'Scheduled post stopped': 'Zaplanowany post został zatrzymany',
  'New winter menu idea': 'Nowy pomysł na zimowe menu',
  Agency: 'Agencja',
  Platform: 'Platforma',
  Workspace: 'Przestrzeń robocza',
  Search: 'Szukaj',
  Notifications: 'Powiadomienia',
  'You are all caught up': 'Wszystko jest na bieżąco',
  'Signed in as Anna Nowak': 'Zalogowano jako Anna Nowak',
  'Message sent to Hakusana': 'Wiadomość wysłana do Hakusana',
  Modules: 'Moduły',
  'Social Media': 'Media społecznościowe',
  'Email marketing': 'E-mail marketing',
  Ads: 'Reklamy',
  Automations: 'Automatyzacje',
  'Coming soon — ask your agency': 'Wkrótce — zapytaj swoją agencję',
  'Connected profiles': 'Połączone profile',
  'Facebook Page': 'Strona na Facebooku',
  'Business account': 'Konto firmowe',
  'LinkedIn company page': 'Strona firmowa LinkedIn',
  'Not connected': 'Nie połączono',
  'Invite to connect': 'Zaproś do połączenia',
  'Connect a profile': 'Połącz profil',
  'Manage connections': 'Zarządzaj połączeniami',
  'Choose a channel to simulate connecting a profile.':
    'Wybierz kanał, aby zasymulować połączenie profilu.',
  'LinkedIn company': 'Firma na LinkedIn',
  'LinkedIn personal': 'Profil osobisty LinkedIn',
  'Profile connected successfully': 'Profil został połączony',
  'Invitation sent to Marek': 'Wysłano zaproszenie do Marka',
  Planned: 'W planie',
  'AMY is working': 'AMY pracuje',
  'Needs your review': 'Czeka na Twoją akceptację',
  Approved: 'Zatwierdzony',
  'Approved · Stopped': 'Zatwierdzony · Zatrzymany',
  Scheduled: 'Zaplanowany',
  Published: 'Opublikowany',
  'Published on 3 of 4': 'Opublikowano w 3 z 4 kanałów',
  'Needs your input': 'Wymaga Twojej odpowiedzi',
  'Intentionally empty': 'Celowo puste',
  'Free slot': 'Wolne miejsce',
  Photo: 'Zdjęcie',
  Carousel: 'Karuzela',
  Reel: 'Rolka',
  Story: 'Relacja',
  PDF: 'PDF',
  Video: 'Wideo',
  Audio: 'Audio',
  'Finish setting up · {n} of 7 done': 'Dokończ konfigurację · ukończono {n} z 7',
  'Continue setup': 'Kontynuuj konfigurację',
  'Awaiting approval from Anna Nowak': 'Oczekuje na akceptację Anny Nowak',
  'A quick review keeps your calendar moving.': 'Szybka akceptacja pozwala trzymać się planu.',
  'Previous week': 'Poprzedni tydzień',
  'Next week': 'Następny tydzień',
  '16 – 22 November 2026': '16–22 listopada 2026',
  'Week of 16 Nov': 'Tydzień od 16 lis',
  '{d} Nov': '{d} lis',
  Mon: 'Pon',
  Tue: 'Wt',
  Wed: 'Śr',
  Thu: 'Czw',
  Fri: 'Pt',
  '{d} video': '{d} wideo',
  'Review posts': 'Przegląd postów',
  '{i} of {n} · {posts} across {ch}': '{i} z {n} · {posts} w {ch}',
  '{day} November · {time} · Europe/Warsaw': '{day} listopada · {time} · Europe/Warsaw',
  'What changed': 'Co się zmieniło',
  'Updated photo brightness and made the opening line warmer.':
    'Rozjaśniono zdjęcie i ocieplono pierwsze zdanie.',
  Before: 'Przed',
  After: 'Po',
  Caption: 'Podpis',
  Comments: 'Komentarze',
  'All reviewed': 'Wszystko przejrzane',
  'Nothing else needs your review right now.': 'Nic więcej nie wymaga teraz Twojej akceptacji.',
  'Back to calendar': 'Wróć do kalendarza',
  'Reject idea': 'Odrzuć pomysł',
  Comment: 'Komentarz',
  'Stop scheduled post': 'Zatrzymaj zaplanowany post',
  'Only scheduled posts can be stopped': 'Można zatrzymać tylko zaplanowane posty',
  'This idea has been rejected. Would you like AMY to prepare a different idea for this slot?':
    'Ten pomysł został odrzucony. Czy AMY ma przygotować inny pomysł na to miejsce?',
  'Yes, create a new idea': 'Tak, utwórz nowy pomysł',
  'No, leave the slot empty': 'Nie, zostaw to miejsce puste',
  'Add a comment': 'Dodaj komentarz',
  'Write a note about this post': 'Napisz notatkę do tego posta',
  'Save comment': 'Zapisz komentarz',
  Cancel: 'Anuluj',
  'Request changes': 'Poproś o zmiany',
  "Tell AMY what you'd like adjusted.": 'Napisz AMY, co chcesz zmienić.',
  'Your feedback': 'Twoje uwagi',
  'For example: brighten the photo and keep the caption as it is.':
    'Na przykład: rozjaśnij zdjęcie, a podpis zostaw bez zmian.',
  'Apply to versions': 'Zastosuj do wersji',
  ' and ': ' i ',
  'Add material': 'Dodaj materiał',
  'Send to AMY': 'Wyślij do AMY',
  'Material picker opened': 'Otwarto wybór materiałów',
  Close: 'Zamknij',
  General: 'Ogólne',
  'Winter menu campaign': 'Kampania menu zimowego',
  'Gingerbread latte': 'Piernikowe latte',
  'Your creative partner': 'Twój kreatywny partner',
  'AMY · {time}': 'AMY · {time}',
  'You · {time}': 'Ty · {time}',
  'You · just now': 'Ty · przed chwilą',
  'Good morning, Anna! I have two posts ready for review and a little idea for the winter menu. What would you like to work on?':
    'Dzień dobry, Anno! Mam dwa posty gotowe do przeglądu i mały pomysł na zimowe menu. Nad czym chcesz popracować?',
  'Review post': 'Przejrzyj post',
  'Approve & schedule': 'Zatwierdź i zaplanuj',
  More: 'Więcej',
  'Post approved and scheduled': 'Post zatwierdzony i zaplanowany',
  'AMY is working on {posts}… 60%': 'AMY pracuje nad {posts}… 60%',
  'Ask AMY anything…': 'Zapytaj AMY…',
  Send: 'Wyślij',
  'Add attachment': 'Dodaj załącznik',
  'Close chat': 'Zamknij czat',
  'Message sent to AMY': 'Wiadomość wysłana do AMY',
  'Choose a photo or document to attach': 'Wybierz zdjęcie lub dokument do załączenia',
  'Material bank': 'Materiały',
  'Your creative library for Brzoza Coffee': 'Twoja kreatywna biblioteka dla Brzoza Coffee',
  'Add photos, videos or audio': 'Dodaj zdjęcia, filmy lub audio',
  'Choose files from your phone camera, library or computer':
    'Wybierz pliki z aparatu telefonu, galerii lub komputera',
  'Connected folder · Last checked 5 min ago': 'Połączony folder · Ostatnio sprawdzono 5 min temu',
  Connected: 'Połączono',
  'Search materials': 'Szukaj materiałów',
  'All files': 'Wszystkie pliki',
  Photos: 'Zdjęcia',
  Videos: 'Filmy',
  Uploaded: 'Przesłane',
  Drive: 'Dysk Google',
  'Used in {x}': 'Użyto w {x}',
  'Winter counter': 'Zimowa lada',
  'Brzoza beans': 'Ziarna Brzoza',
  'Weekend reel': 'Weekendowa rolka',
  'Cafe at dusk': 'Kawiarnia o zmierzchu',
  'Latte art': 'Latte art',
  'Morning playlist': 'Poranna playlista',
  'Upload queue': 'Kolejka przesyłania',
  '100% · Processing preview': '100% · Przygotowywanie podglądu',
  '42% · Keep this screen open': '42% · Nie zamykaj tego ekranu',
  Paused: 'Wstrzymano',
  'Resume upload': 'Wznów przesyłanie',
  'Pause upload': 'Wstrzymaj przesyłanie',
  'Cancel upload': 'Anuluj przesyłanie',
  'Preview processing cancelled': 'Anulowano przygotowywanie podglądu',
  'Upload cancelled': 'Anulowano przesyłanie',
  'Missing material': 'Brakujący materiał',
  "Add clips for next week's Reels": 'Dodaj klipy do rolek na przyszły tydzień',
  'Upload clips': 'Prześlij klipy',
  'Use photos instead': 'Użyj zdjęć',
  'Select video clips to upload': 'Wybierz klipy wideo do przesłania',
  'AMY will prepare a photo-based version': 'AMY przygotuje wersję opartą na zdjęciach',
  'Before uploading': 'Przed przesłaniem',
  'Video up to 10 GB · Image 200 MB · Audio 2 GB':
    'Wideo do 10 GB · Zdjęcie do 200 MB · Audio 2 GB',
  "Your photos and videos stay in your Google Drive. AMY only keeps copies of what's used in your posts.":
    'Twoje zdjęcia i filmy zostają na Twoim Dysku Google. AMY zachowuje tylko kopie tego, co jest użyte w postach.',
  'Plan allowance': 'Limit planu',
  'Your monthly publishing allowance. One post per channel per day.':
    'Twój miesięczny limit publikacji. Jeden post na kanał dziennie.',
  '{x} this month': '{x} w tym miesiącu',
  'Tap to see usage details': 'Dotknij, aby zobaczyć szczegóły',
  '{c}: {p} published · {r} reserved · {a} available':
    '{c}: opublikowane: {p} · zarezerwowane: {r} · dostępne: {a}',
  'AI usage': 'Użycie AI',
  'Billed by your AI provider': 'Rozliczane przez Twojego dostawcę AI',
  Estimate: 'Szacunek',
  'Connected provider': 'Połączony dostawca',
  'Estimated this month': 'Szacunkowo w tym miesiącu',
  'Of estimated monthly usage': 'Szacowanego miesięcznego użycia',
  'View usage details': 'Zobacz szczegóły użycia',
  'AI usage details opened': 'Otwarto szczegóły użycia AI',
  Settings: 'Ustawienia',
  'People, permissions and connected accounts.': 'Osoby, uprawnienia i połączone konta.',
  'People & permissions': 'Osoby i uprawnienia',
  'Invite contributor': 'Zaproś współpracownika',
  'Invite link copied for a new contributor':
    'Skopiowano link z zaproszeniem dla nowego współpracownika',
  Owner: 'Właściciel',
  Contributor: 'Współpracownik',
  'Can approve posts': 'Może zatwierdzać posty',
  'Contributors can approve content for publishing.':
    'Współpracownicy mogą zatwierdzać treści do publikacji.',
  'Marek can approve content for publishing.': 'Marek może zatwierdzać treści do publikacji.',
  'Can stop posts': 'Może zatrzymywać posty',
  'Contributors can stop a scheduled post.': 'Współpracownicy mogą zatrzymać zaplanowany post.',
  'Marek can stop a scheduled post.': 'Marek może zatrzymać zaplanowany post.',
  'Toggle post approvals': 'Przełącz zatwierdzanie postów',
  'Toggle stopping posts': 'Przełącz zatrzymywanie postów',
  Connections: 'Połączenia',
  'Needs reconnecting': 'Wymaga ponownego połączenia',
  'Invite Marek to connect': 'Zaproś Marka do połączenia',
  Manage: 'Zarządzaj',
  Reconnect: 'Połącz ponownie',
  Invite: 'Zaproś',
  '{x}: connection action opened': '{x}: otwarto akcję połączenia',
  'Pause all publishing': 'Wstrzymaj wszystkie publikacje',
  'Stop all scheduled posts until you turn publishing back on.':
    'Zatrzymaj wszystkie zaplanowane posty, dopóki ponownie nie włączysz publikowania.',
  'Publishing paused by Anna': 'Publikowanie wstrzymane przez Annę',
  'The look, voice and feel AMY uses for Brzoza Coffee.':
    'Wygląd, głos i charakter, których AMY używa dla Brzoza Coffee.',
  'Update brand style': 'Zaktualizuj styl marki',
  'Brand style editor opened': 'Otwarto edytor stylu marki',
  'Active style · v1': 'Aktywny styl · v1',
  Active: 'Aktywny',
  'Warm, natural and quietly confident. A neighbourhood cafe with room to slow down.':
    'Ciepła, naturalna i spokojnie pewna siebie. Osiedlowa kawiarnia z miejscem na zwolnienie tempa.',
  Colours: 'Kolory',
  Cream: 'Kremowy',
  Forest: 'Leśny',
  Ink: 'Atramentowy',
  Typography: 'Typografia',
  'Approved sample posts': 'Zatwierdzone przykładowe posty',
  'Winter menu launch · Instagram': 'Start menu zimowego · Instagram',
  'Our Warsaw morning · Facebook': 'Nasz warszawski poranek · Facebook',
  'Meet the roaster · LinkedIn': 'Poznaj palacza kawy · LinkedIn',
  'Approved by Anna · {n} Nov': 'Zatwierdziła Anna · {n} lis',
  'Opened {x}': 'Otwarto: {x}',
  'Version history': 'Historia wersji',
  'v1 · Active': 'v1 · Aktywna',
  'Published 3 November by Anna': 'Opublikowana 3 listopada przez Annę',
  'v2 · Draft': 'v2 · Wersja robocza',
  'Updated 8 November': 'Zaktualizowana 8 listopada',
  Preview: 'Podgląd',
  'Draft preview opened': 'Otwarto podgląd wersji roboczej',
  "A simple view of what's working this month.": 'Prosty podgląd tego, co działa w tym miesiącu.',
  'Export report': 'Eksportuj raport',
  'Report export prepared': 'Eksport raportu gotowy',
  'Reach this month · +18%': 'Zasięg w tym miesiącu · +18%',
  'Engagement · +0.8%': 'Zaangażowanie · +0,8%',
  'Posts published': 'Opublikowane posty',
  'Channel performance': 'Wyniki kanałów',
  '{x} reach': 'zasięg: {x}',
  'Ideas & campaigns': 'Pomysły i kampanie',
  'Plan creative work together, one good idea at a time.':
    'Planuj pracę twórczą — jeden dobry pomysł naraz.',
  'New campaign': 'Nowa kampania',
  'New campaign draft created': 'Utworzono wersję roboczą kampanii',
  'Winter menu campaign ': 'Kampania menu zimowego',
  'Slow mornings': 'Leniwe poranki',
  'Holiday opening hours': 'Godziny otwarcia w święta',
  '16–29 November': '16–29 listopada',
  'Always-on': 'Stale aktywna',
  December: 'Grudzień',
  Draft: 'Wersja robocza',
  'Open campaign': 'Otwórz kampanię',
  '{x} opened': 'Otwarto: {x}',
  'Finish setting up': 'Dokończ konfigurację',
  'A few quick steps to get Brzoza Coffee ready · {n} of 7 done':
    'Kilka szybkich kroków, by przygotować Brzoza Coffee · ukończono {n} z 7',
  'Business details': 'Dane firmy',
  'Brand & style': 'Marka i styl',
  'Add your photos and videos': 'Dodaj swoje zdjęcia i filmy',
  'Connect AI': 'Połącz AI',
  'Connect social accounts': 'Połącz konta społecznościowe',
  'Approve sample posts': 'Zatwierdź przykładowe posty',
  'Activate your plan': 'Aktywuj swój plan',
  '2–4 min': '2–4 min',
  '2–5 min each': '2–5 min na konto',
  '3–5 min': '3–5 min',
  '1 min': '1 min',
  Done: 'Gotowe',
  'Saved for later · {time}': 'Odłożone na później · {time}',
  'Do this later': 'Zrobię to później',
  Open: 'Otwórz',
  Continue: 'Kontynuuj',
  '{x} marked complete': '{x}: oznaczono jako gotowe',
  '{x}: you can do this later': '{x}: możesz to zrobić później',
  'An API key lets AMY use your AI account. Your AI provider bills you separately.':
    'Klucz API pozwala AMY korzystać z Twojego konta AI. Dostawca AI rozlicza się z Tobą osobno.',
  'API key': 'Klucz API',
  'Test connection': 'Przetestuj połączenie',
  'Ask someone to do this for me': 'Poproś kogoś o pomoc',
  'Connection successful': 'Połączenie działa',
  'Finish this step': 'Zakończ ten krok',
  'Invite someone to connect AI': 'Zaproś kogoś do połączenia AI',
  Name: 'Imię i nazwisko',
  Email: 'E-mail',
  'Send invitation': 'Wyślij zaproszenie',
  'Invitation sent to {name}': 'Zaproszenie wysłane do: {name}',
  calendar: 'Kalendarz',
  ideas: 'Pomysły i kampanie',
  materials: 'Materiały',
  brand: 'Marka',
  reports: 'Raporty',
  allowance: 'Limit planu',
  settings: 'Ustawienia',
  contact: 'Skontaktuj się z agencją',
  title: 'Kalendarz treści',
  subtitle: 'Menu zimowe · 16–29 listopada 2026',
  addIdea: 'Dodaj pomysł',
  review: '6 postów czeka na akceptację',
  startReview: 'Rozpocznij przegląd',
  scheduled: 'Zaplanowane',
  published: 'Opublikowane',
  health: 'Status publikacji',
  today: 'Dzisiaj',
  month: 'Miesiąc',
  week: 'Tydzień',
  list: 'Lista',
  previous: 'Poprzedni',
  next: 'Następny',
  owner: 'Właściciel klienta',
  contributor: 'Współpracownik klienta',
  agency: 'Pracownik agencji',
  admin: 'Administrator platformy',
  chat: 'Czat z AMY',
  send: 'Wyślij',
  placeholder: 'Zapytaj AMY…',
  general: 'Ogólne',
  campaign: 'Menu zimowe',
  postThread: 'Piernikowe latte',
  reviewTitle: 'Przegląd postów',
  approve: 'Zatwierdź i zaplanuj',
  request: 'Poproś o zmiany',
  more: 'Więcej',
  close: 'Zamknij',
  skip: 'Pomiń',
  approvedToast: 'Post zatwierdzony i zaplanowany',
  changesToast: 'AMY otrzymała Twoje uwagi',
  ideaToast: 'Pomysł dodany do kalendarza',
  upload: 'Dodaj zdjęcia, filmy lub audio',
  all: 'Wszystkie pliki',
  photos: 'Zdjęcia',
  videos: 'Filmy',
  audio: 'Audio',
  search: 'Szukaj',
  viewClient: 'Zobacz jako klient',
  prototype: 'Prototyp: widok jako',
  mobile: 'Podgląd mobilny',
  onboarding: 'Lista wdrożeniowa',
  onePost: 'post',
  fewPosts: 'posty',
  manyPosts: 'postów',
  searchHint: 'Szukaj w przestrzeni',
  agencyHome: 'Przegląd',
  platformHome: 'Panel platformy',
  roleOwner: 'Właściciel klienta',
  roleContributor: 'Współpracownik',
  roleAgency: 'Pracownik agencji',
  roleAdmin: 'Administrator',
  'Posting times': 'Godziny publikacji',
  'Daily allowance': 'Dzienny limit',
  reviewCount: '{n} {posts} {verb} na Twoją akceptację',
  'reviewVerb.one': 'czeka',
  'reviewVerb.other': 'czeka',
  'post.one': 'post',
  'post.other': 'postów',
  'postIn.one': 'poście',
  'postIn.other': 'postach',
  'postWith.one': 'postem',
  'postWith.other': 'postami',
  'channel.one': 'kanał',
  'channel.other': 'kanałów',
  'channelIn.one': 'kanale',
  'channelIn.other': 'kanałach',
  'idea.one': 'pomysł',
  'idea.other': 'pomysłów',
  'availability.one': 'dostępny dziś',
  'availability.other': 'dostępnych dziś',
  'avail.one': 'dostępny post',
  'avail.other': 'dostępnych postów',
  of: 'z',
  Language: 'Język',
  'Pause video': 'Wstrzymaj wideo',
  'Play video': 'Odtwórz wideo',
  'Unmute video': 'Włącz dźwięk',
  'Mute video': 'Wycisz wideo',
  'Toggle captions': 'Przełącz napisy',
  'Choose version': 'Wybierz wersję',
  Back: 'Wstecz',
  'Close menu': 'Zamknij menu',
  Brand: 'Marka',
  Reports: 'Raporty',
  CC: 'Napisy',
  'Week of {date}': 'Tydzień od {date}',
  'Agency home': 'Panel agencji',
  'View as client': 'Zobacz jako klient',
  'Needs attention': 'Wymaga uwagi',
  Cause: 'Przyczyna',
  'Affected items': 'Dotyczy',
  Age: 'Od kiedy',
  Action: 'Działanie',
  'Revision failed': 'Poprawka nie powiodła się',
  'TikTok connection expired': 'Połączenie z TikTokiem wygasło',
  'Awaiting client review': 'Czeka na akceptację klienta',
  'Waiting for client': 'Czeka na klienta',
  Retry: 'Ponów',
  'Send reminder': 'Wyślij przypomnienie',
  'Open review': 'Otwórz przegląd',
  '{action}: started': '{action}: rozpoczęto',
  'Upcoming publications': 'Nadchodzące publikacje',
  'Today {time}': 'Dziś {time}',
  'Tomorrow {time}': 'Jutro {time}',
  Workspaces: 'Przestrzenie robocze',
  Healthy: 'Działa',
  '{n} for review': 'Do akceptacji: {n}',
  'Open {name}': 'Otwórz: {name}',
  'item.one': 'element',
  'item.other': 'elementu',
  'Platform overview': 'Przegląd platformy',
  'Platform settings and operational health.': 'Ustawienia platformy i stan działania.',
  'Provider incident · TikTok media processing':
    'Incydent u dostawcy · przetwarzanie multimediów w TikToku',
  'Some video revisions may take longer than usual.':
    'Niektóre poprawki wideo mogą potrwać dłużej niż zwykle.',
  'View details': 'Zobacz szczegóły',
  'Incident details opened': 'Otwarto szczegóły incydentu',
  Agencies: 'Agencje',
  agencyActive: 'Aktywna',
  'workspace.one': 'przestrzeń',
  'workspace.other': 'przestrzeni',
  'Social media': 'Media społecznościowe',
  On: 'Włączony',
  Configure: 'Konfiguruj',
  'Social media module settings opened': 'Otwarto ustawienia modułu mediów społecznościowych',
  'Coming soon': 'Wkrótce',
  'Media operations': 'Operacje na multimediach',
  'Max video length': 'Maksymalna długość wideo',
  'Render-minutes alert': 'Alert minut renderowania',
  '{value} per workspace': '{value} na przestrzeń',
  Storage: 'Przechowywanie',
  'Originals deleted after processing': 'Oryginały usuwane po przetworzeniu',
  Copies: 'Kopie',
  'Drive-linked or stored copies': 'Pliki z Dysku Google lub zapisane kopie',
  'Edit limits': 'Edytuj limity',
  'Media operation settings opened': 'Otwarto ustawienia operacji na multimediach',
  'Support access log': 'Dziennik dostępu wsparcia',
  'Hakusana support viewed Brzoza Coffee': 'Wsparcie Hakusana wyświetliło Brzoza Coffee',
  '{name} approved access': '{name} zatwierdziła dostęp',
  'View access log': 'Zobacz dziennik dostępu',
  'Full support access log opened': 'Otwarto pełny dziennik dostępu wsparcia',
  'Daily slot settings': 'Ustawienia dziennych limitów',
  Channel: 'Kanał',
  'Agency default': 'Domyślnie w agencji',
  'Workspace override': 'Zmiana dla przestrzeni',
  'Effective value': 'Obowiązująca wartość',
  Mode: 'Tryb',
  Inherit: 'Dziedzicz',
  Override: 'Nadpisz',
  '{n} per day': '{n} dziennie',
  '(Reel/Story)': '(Rolka/Relacja)',
  '{channel}: {mode} selected': '{channel}: wybrano „{mode}”',
  'Changes apply to new bookings. Existing scheduled posts are kept.':
    'Zmiany dotyczą nowych rezerwacji. Zaplanowane posty pozostają bez zmian.',
  'reviewVerb.few': 'czekają',
  'reviewVerb.many': 'czeka',
  'post.few': 'posty',
  'post.many': 'postów',
  'postIn.few': 'postach',
  'postIn.many': 'postach',
  'postWith.few': 'postami',
  'postWith.many': 'postami',
  'channel.few': 'kanały',
  'channel.many': 'kanałów',
  'channelIn.few': 'kanałach',
  'channelIn.many': 'kanałach',
  'idea.few': 'pomysły',
  'idea.many': 'pomysłów',
  'availability.few': 'dostępne dziś',
  'availability.many': 'dostępnych dziś',
  'avail.few': 'dostępne posty',
  'avail.many': 'dostępnych postów',
  'item.few': 'elementy',
  'item.many': 'elementów',
  'workspace.few': 'przestrzenie',
  'workspace.many': 'przestrzeni',
  Prototype: 'Prototyp',
  'Prototype controls': 'Ustawienia prototypu',
  'Approve & schedule: {post}': 'Zatwierdź i zaplanuj: {post}',
  Conversation: 'Rozmowa',
  '{name} · {n} new': '{name} · nowe: {n}',
  'Reviewing: {post}': 'Przeglądasz: {post}',
  'Can you make a post about our new gingerbread latte for Monday morning?':
    'Czy możesz przygotować post o naszym nowym piernikowym latte na poniedziałkowy poranek?',
  "Sure! I've drafted an Instagram Reel for Monday 16 November at 9:00. Want to review it now?":
    'Jasne! Przygotowałam rolkę na Instagram na poniedziałek 16 listopada o 9:00. Chcesz ją teraz obejrzeć?',
  'Use the buttons under the post to approve or request changes. Ask AMY here if something is unclear.':
    'Użyj przycisków pod postem, aby go zatwierdzić lub poprosić o zmiany. Jeśli coś jest niejasne, zapytaj tutaj AMY.',
  'Choose at least one version.': 'Wybierz co najmniej jedną wersję.',
  'AMY will update the {v} versions: “{request}”':
    'AMY zaktualizuje wersje: {v}. Twoja prośba: „{request}”',
  'Write what to change. AMY will update the {v} versions.':
    'Napisz, co zmienić. AMY zaktualizuje wersje: {v}.',
  'TikTok needs reconnecting': 'TikTok wymaga ponownego połączenia',
  'Anna Nowak can reconnect it in Settings': 'Anna Nowak może go ponownie połączyć w Ustawieniach',
  '3 of 4 channels working': 'Działają 3 z 4 kanałów',
  'Reconnect TikTok': 'Połącz ponownie TikTok',
  Linked: 'Z Dysku Google',
  'Used in posts': 'Użyte w postach',
  'Preparing media': 'Przygotowujemy plik',
  'We keep an optimised copy for your posts. Keep your originals on your phone or drive.':
    'Zachowujemy zoptymalizowaną kopię do Twoich postów. Oryginały trzymaj w telefonie lub na swoim dysku.',
  'Which AI provider do you use?': 'Z którego dostawcy AI korzystasz?',
  'Sign in to {provider}': 'Zaloguj się: {provider}',
  'Use the account your business pays from. No account yet? You can create one on the same page.':
    'Użyj konta, z którego płaci Twoja firma. Nie masz konta? Założysz je na tej samej stronie.',
  'Open {provider}': 'Otwórz: {provider}',
  'Add a payment method': 'Dodaj metodę płatności',
  '{provider} bills you directly for AI use. AMY never sees your card details.':
    '{provider} rozlicza korzystanie z AI bezpośrednio z Tobą. AMY nigdy nie widzi danych Twojej karty.',
  'Open billing': 'Otwórz płatności',
  'Create a key named "AMY"': 'Utwórz klucz o nazwie „AMY”',
  'Choose "Create key", type AMY as the name, then copy the key. It is shown only once.':
    'Wybierz „Create key”, wpisz nazwę AMY i skopiuj klucz. Jest widoczny tylko raz.',
  'Paste it below and test': 'Wklej go poniżej i sprawdź',
  'AMY checks the key straight away and tells you if anything is missing.':
    'AMY od razu sprawdzi klucz i powie, czy czegoś brakuje.',
  'What it costs': 'Ile to kosztuje',
  'Example: about 30 posts a month usually costs a few euros of AI use. Prices checked {date}; your provider shows the exact amount.':
    'Przykład: około 30 postów miesięcznie to zwykle kilka euro za korzystanie z AI. Ceny sprawdzone {date}; dokładną kwotę pokazuje Twój dostawca.',
  'We will email them these steps and a secure link. You do not need to share your password.':
    'Wyślemy tej osobie e-mailem te kroki i bezpieczny link. Nie musisz udostępniać swojego hasła.',
  'Ask Anna Nowak to change this, or suggest a change.':
    'Poproś Annę Nowak o zmianę albo zaproponuj zmianę.',
  'Tone of voice': 'Ton wypowiedzi',
  'Emoji, hashtags and calls to action': 'Emoji, hashtagi i wezwania do działania',
  'Words we use and avoid': 'Słowa, których używamy i unikamy',
  'Anything else AMY should know': 'Dodatkowe wskazówki dla AMY',
  '{hex} copied': 'Skopiowano {hex}',
  'Brand update applied to future content and existing drafts':
    'Zmiany marki zastosowano w nowych treściach i istniejących szkicach',
  'Brand update applied to future content': 'Zmiany marki zastosowano w nowych treściach',
  'Active · v1': 'Aktywna · v1',
  'AMY uses this brand guide when creating and revising your content.':
    'AMY korzysta z tego przewodnika marki, gdy tworzy i poprawia Twoje treści.',
  'Suggestion sent to Anna Nowak': 'Propozycję wysłano do Anny Nowak',
  'Suggest a change': 'Zaproponuj zmianę',
  'Preview draft v2': 'Podgląd szkicu v2',
  'Brand sections': 'Sekcje marki',
  'Brand basics': 'Podstawy marki',
  'Who you are and the facts AMY can rely on.': 'Kim jesteście i jakie fakty AMY może podawać.',
  'In one sentence': 'W jednym zdaniu',
  'A neighbourhood cafe in Warsaw that roasts its own beans.':
    'Osiedlowa kawiarnia w Warszawie, która sama pali ziarna.',
  'Who we talk to': 'Do kogo mówimy',
  'Locals, remote workers and weekend regulars, mostly 25–45.':
    'Mieszkańcy okolicy, osoby pracujące zdalnie i weekendowi stali goście, głównie 25–45 lat.',
  'Key products': 'Najważniejsze produkty',
  'Seasonal lattes, single-origin filter coffee, homemade cakes.':
    'Sezonowe latte, kawa przelewowa single origin, domowe ciasta.',
  'Verified facts': 'Sprawdzone fakty',
  'ul. Brzozowa 12, Warsaw · Beans roasted in Warsaw · Oat milk at no extra cost':
    'ul. Brzozowa 12, Warszawa · Ziarna palone w Warszawie · Mleko owsiane bez dopłaty',
  'Opening hours and offers change often, so AMY reads them from Settings › Business details.':
    'Godziny otwarcia i oferty często się zmieniają, więc AMY pobiera je z Ustawień › Dane firmy.',
  'Visual style': 'Styl wizualny',
  'Logos, colours, fonts and photo style.': 'Logo, kolory, czcionki i styl zdjęć.',
  'Brand assets': 'Materiały marki',
  'Preview background': 'Tło podglądu',
  'Choose brand files from your phone, computer or Drive':
    'Wybierz pliki marki z telefonu, komputera lub Dysku Google',
  'Add brand file': 'Dodaj plik marki',
  'Campaign photos and videos live in the Material bank.':
    'Zdjęcia i filmy do kampanii znajdziesz w Materiałach.',
  'Copy {hex}': 'Kopiuj {hex}',
  'Readability checks': 'Czytelność',
  'Contrast between real text and background pairs. AA needs 4.5:1 for normal text and 3:1 for large text.':
    'Kontrast prawdziwych par tekstu i tła. Poziom AA wymaga 4,5:1 dla zwykłego tekstu i 3:1 dla dużego.',
  '{fg} on {bg}': '{fg} na tle: {bg}',
  Fonts: 'Czcionki',
  'Font not loaded, showing a fallback': 'Czcionka się nie wczytała, widać zamiennik',
  'Winter menu': 'Menu zimowe',
  'Slow mornings, good coffee': 'Spokojne poranki, dobra kawa',
  'Our gingerbread latte is back, made with beans we roast ourselves in Warsaw. Come in and take the window seat.':
    'Piernikowe latte wróciło. Robimy je z ziaren, które sami palimy w Warszawie. Wpadnij i zajmij miejsce przy oknie.',
  'Photo style': 'Styl zdjęć',
  'Natural daylight, warm tones': 'Naturalne światło dzienne, ciepłe barwy',
  'Real guests and staff, never stock photos': 'Prawdziwi goście i zespół, nigdy zdjęcia stockowe',
  'Cups and cakes close up, wooden tables': 'Kubki i ciasta z bliska, drewniane stoły',
  'Logo use': 'Używanie logo',
  'Keep space around the logo the size of the leaf':
    'Zostaw wokół logo wolne miejsce wielkości liścia',
  'Use the light logo on photos and dark colours':
    'Na zdjęciach i ciemnych kolorach używaj jasnego logo',
  'Never stretch, recolour or add effects':
    'Nie rozciągaj, nie zmieniaj kolorów i nie dodawaj efektów',
  'How AMY writes': 'Jak pisze AMY',
  'Choose how your posts should sound. AMY follows this for every caption.':
    'Wybierz, jak mają brzmieć Twoje posty. AMY trzyma się tego w każdym opisie.',
  'Choose one or more.': 'Wybierz jedną lub kilka opcji.',
  'Remove {word}': 'Usuń: {word}',
  'Add a word or phrase': 'Dodaj słowo lub wyrażenie',
  Add: 'Dodaj',
  'Content languages': 'Języki treści',
  'Polish · main language': 'Polski · główny język',
  'Informal "Ty". Use Polish quotation marks „…”.':
    'Zwracamy się na „Ty”. Używamy polskich cudzysłowów „…”.',
  'English · for LinkedIn and tourists': 'Angielski · na LinkedIn i dla turystów',
  'British spelling. Keep Polish place names.':
    'Pisownia brytyjska. Polskie nazwy miejsc bez zmian.',
  'Anything else AMY should know?': 'Co jeszcze AMY powinna wiedzieć?',
  'These notes guide writing only. They cannot change permissions, approvals or platform rules.':
    'Te wskazówki dotyczą tylko pisania. Nie zmieniają uprawnień, akceptacji ani zasad platform.',
  '"Playful" and "Clear and professional" can pull in different directions. AMY will ask which one wins when they conflict.':
    '„Zabawny” i „Jasny i profesjonalny” mogą się wykluczać. Gdy dojdzie do konfliktu, AMY zapyta, który wybrać.',
  'Examples & history': 'Przykłady i historia',
  'What good looks like, and what to avoid.': 'Jak wygląda dobry post i czego unikać.',
  'Good examples': 'Dobre przykłady',
  'Approved by Anna · {date}': 'Zaakceptowała Anna · {date}',
  Avoid: 'Unikaj',
  'Change history': 'Historia zmian',
  'Applied 3 November by Anna Nowak · First brand guide':
    'Zastosowała Anna Nowak 3 listopada · Pierwszy przewodnik marki',
  'Started 8 November by Marek (agency) · Added English notes':
    'Rozpoczął Marek (agencja) 8 listopada · Dodano wskazówki po angielsku',
  'Brand guide status': 'Stan przewodnika marki',
  'Active since {date}': 'Aktywna od {date}',
  'Draft · changes: {n}': 'Szkic · zmiany: {n}',
  'English language notes': 'Wskazówki dla języka angielskiego',
  'Review and apply': 'Sprawdź i zastosuj',
  'Anna Nowak applies brand updates.': 'Zmiany marki zatwierdza Anna Nowak.',
  'The client owner applies brand updates. Your changes are saved as a draft.':
    'Zmiany marki zatwierdza właściciel konta klienta. Twoje zmiany zapisują się jako szkic.',
  'Try this style': 'Wypróbuj ten styl',
  'See how AMY would write a post with the draft settings.':
    'Zobacz, jak AMY napisałaby post z ustawieniami szkicu.',
  'Write a sample post': 'Napisz przykładowy post',
  'Sample preview': 'Przykładowy podgląd',
  'With your draft': 'Ze szkicem',
  'With the active style': 'Z aktywnym stylem',
  'Apply brand updates': 'Zastosuj zmiany marki',
  'v2 replaces v1 for new content.': 'W nowych treściach v2 zastąpi v1.',
  'What changes': 'Co się zmienia',
  'Approved and scheduled posts keep the style they were approved with.':
    'Zaakceptowane i zaplanowane posty zachowują styl, z którym je zaakceptowano.',
  'Also update drafts that are not approved yet':
    'Zaktualizuj też szkice, które nie są jeszcze zaakceptowane',
  'Main logo': 'Główne logo',
  'For dark backgrounds': 'Na ciemne tło',
  Icon: 'Ikona',
  Storefront: 'Witryna',
  'Profile pictures': 'Zdjęcia profilowe',
  'PDF · 2 pages': 'PDF · 2 strony',
  'Use on light backgrounds': 'Na jasne tło',
  'Use on dark backgrounds': 'Na ciemne tło',
  Transparent: 'Przezroczyste',
  Light: 'Jasne',
  Dark: 'Ciemne',
  Cinnamon: 'Cynamon',
  'Birch bark': 'Kora brzozy',
  Primary: 'Główny',
  Background: 'Tło',
  Text: 'Tekst',
  Accent: 'Akcent',
  'Light accent': 'Jasny akcent',
  'Captions and body text': 'Opisy i tekst główny',
  'Headlines on cream': 'Nagłówki na kremowym tle',
  'Text on green banners': 'Tekst na zielonych banerach',
  'Offer badges': 'Plakietki z ofertą',
  'Small accent text': 'Drobny tekst w kolorze akcentu',
  Headings: 'Nagłówki',
  'Body text': 'Tekst główny',
  Passes: 'Zaliczone',
  'Large text only': 'Tylko duży tekst',
  Fails: 'Niezaliczone',
  'Calm and warm': 'Spokojny i ciepły',
  'Friendly and relaxed': 'Przyjazny i swobodny',
  'Clear and professional': 'Jasny i profesjonalny',
  Playful: 'Zabawny',
  'Slow mornings are better with a good cup. Come in, sit by the window.':
    'Spokojny poranek smakuje lepiej z dobrą kawą. Wpadnij, usiądź przy oknie.',
  'New on the menu: gingerbread latte. You know what to do ☕':
    'Nowość w menu: piernikowe latte. Wiesz, co robić ☕',
  'Our winter menu is available from 16 November, daily 8:00–19:00.':
    'Menu zimowe jest dostępne od 16 listopada, codziennie 8:00–19:00.',
  'Warning: this gingerbread latte may cause spontaneous cosiness.':
    'Uwaga: piernikowe latte może wywołać nagły przypływ przytulności.',
  Emoji: 'Emoji',
  Hashtags: 'Hashtagi',
  'Call to action': 'Wezwanie do działania',
  None: 'Brak',
  'A few (1–2)': 'Kilka (1–2)',
  Plenty: 'Dużo',
  'Our own (2)': 'Własne (2)',
  'Own and popular (3–5)': 'Własne i popularne (3–5)',
  'Gentle invitation': 'Delikatne zaproszenie',
  'Clear and direct': 'Jasno i wprost',
  'No call to action': 'Bez wezwania do działania',
  'Words we use': 'Słowa, których używamy',
  'Words we avoid': 'Słowa, których unikamy',
  'Warm opening line, one clear invitation, two emoji.':
    'Ciepłe pierwsze zdanie, jedno jasne zaproszenie, dwa emoji.',
  'Shows real people and the window seats.': 'Pokazuje prawdziwych ludzi i miejsca przy oknie.',
  'Professional, but still personal.': 'Profesjonalnie, ale wciąż osobiście.',
  '"Best coffee in Warsaw!!!"': '„Najlepsza kawa w Warszawie!!!”',
  'Superlatives we cannot prove.': 'Superlatywy, których nie możemy udowodnić.',
  'Stock photos of latte art': 'Stockowe zdjęcia latte art',
  'Use our own photos instead.': 'Zamiast nich używaj naszych zdjęć.',
  'Rejected 6 Nov: "too formal" (Meet the roaster v1)':
    'Odrzucono 6 lis: „zbyt formalnie” (Poznaj naszego palacza v1)',
  'One-off feedback, not a rule.': 'Jednorazowa uwaga, nie zasada.',
  'Brand rule': 'Zasada marki',
  'One-off': 'Jednorazowo',
  'Same as the active style. Change a setting to see the difference.':
    'Tak samo jak w aktywnym stylu. Zmień ustawienie, aby zobaczyć różnicę.',
  'Client view opened in read-only mode': 'Otwarto widok klienta tylko do odczytu',
  'Demo data reset': 'Przywrócono dane demonstracyjne',
  'Reset demo': 'Resetuj demo',
  'Viewing {ws} as the client · read-only': 'Widok {ws} jako klient · tylko do odczytu',
  'Hakusana is working in {ws}. The client approves posts.':
    'Hakusana pracuje w: {ws}. Posty akceptuje klient.',
  'Publishing is paused by {name}. Nothing is published until it is resumed.':
    'Publikowanie wstrzymał(a): {name}. Nic nie zostanie opublikowane do czasu wznowienia.',
  'Publishing resumed. Posts whose time passed during the pause will be offered new times.':
    'Publikowanie wznowione. Postom, których termin minął w czasie przerwy, zaproponujemy nowe godziny.',
  'Resume publishing': 'Wznów publikowanie',
  '{network} connection expired': 'Połączenie z {network} wygasło',
  'Reminder sent at {time}': 'Przypomnienie wysłane o {time}',
  'Reminder sent to {name} (simulated)': 'Wysłano przypomnienie do: {name} (symulacja)',
  'Open workspace': 'Otwórz przestrzeń',
  'Material missing': 'Brakuje materiału',
  'Open post': 'Otwórz post',
  'Published on {ok} of {n}': 'Opublikowano na {ok} z {n}',
  'Nothing needs attention right now.': 'Nic teraz nie wymaga uwagi.',
  '{n} connection issue': 'Problemy z połączeniem: {n}',
  'View {name} as the client': 'Zobacz {name} jako klient',
  'Your plan includes one post per channel per day. Unused days do not carry over.':
    'Twój plan obejmuje jeden post na kanał dziennie. Niewykorzystane dni nie przechodzą na kolejne.',
  'Choose a day': 'Wybierz dzień',
  '1 of 1 slot available on this day': 'Tego dnia dostępne jest 1 z 1 miejsc',
  'This day has passed. Unused slots do not carry over.':
    'Ten dzień minął. Niewykorzystane miejsca nie przechodzą dalej.',
  'The slot for this day is taken': 'Miejsce na ten dzień jest zajęte',
  'Next two weeks': 'Najbliższe dwa tygodnie',
  '{n} free days in the next two weeks': 'Wolne dni w ciągu dwóch tygodni: {n}',
  'Reconnect {network} to use these slots':
    'Połącz ponownie {network}, aby korzystać z tych miejsc',
  'Billed by your AI provider, separately from your AMY plan':
    'Rozlicza dostawca AI, osobno od planu AMY',
  'Estimated cost, 1–18 November': 'Szacowany koszt, 1–18 listopada',
  'AMY tasks this month (drafts and revisions)': 'Zadania AMY w tym miesiącu (szkice i poprawki)',
  Reserved: 'Zarezerwowano',
  Available: 'Dostępne',
  'Not used': 'Niewykorzystane',
  'Ask {name} to change this, or suggest a change.':
    'Poproś {name} o zmianę albo zaproponuj zmianę.',
  'No visible changes': 'Brak widocznych zmian',
  'Brand guide v{v} is active. New content and unapproved drafts use it.':
    'Przewodnik marki v{v} jest aktywny. Korzystają z niego nowe treści i niezaakceptowane szkice.',
  'Brand guide v{v} is active for new content.':
    'Przewodnik marki v{v} obowiązuje dla nowych treści.',
  'Active · v{v}': 'Aktywna · v{v}',
  'Draft v{v} · not used for new posts yet': 'Szkic v{v} · jeszcze nieużywany w nowych postach',
  'Draft discarded. The active guide is unchanged.':
    'Szkic odrzucono. Aktywny przewodnik się nie zmienił.',
  'Discard draft': 'Odrzuć szkic',
  'Add colour': 'Dodaj kolor',
  'Add font': 'Dodaj czcionkę',
  'Approved by {name} · {date}': 'Zaakceptowano: {name} · {date}',
  'v{v} · Draft': 'v{v} · Szkic',
  'v{v} · Active': 'v{v} · Aktywna',
  'v{v} · Replaced': 'v{v} · Zastąpiona',
  'No changes yet': 'Jeszcze bez zmian',
  'Applied {date} by {name}': 'Zastosowano {date}, {name}',
  '{name} applies brand updates.': 'Zmiany marki zatwierdza: {name}.',
  'Change anything on this page to start a draft. AMY keeps using the active version until it is applied.':
    'Zmień cokolwiek na tej stronie, aby rozpocząć szkic. Do czasu zatwierdzenia AMY korzysta z aktywnej wersji.',
  'No draft in progress.': 'Brak szkicu w toku.',
  'Settings changed. Write a new sample to see the difference.':
    'Ustawienia się zmieniły. Napisz nowy przykład, aby zobaczyć różnicę.',
  'v{next} replaces v{v} for new content.': 'W nowych treściach v{next} zastąpi v{v}.',
  'Write a new sample': 'Napisz nowy przykład',
  Secondary: 'Drugorzędny',
  Custom: 'Własny',
  'Times in {tz}': 'Godziny: {tz}',
  'I have an idea for a post: ': 'Mam pomysł na post: ',
  'Awaiting approval from {name}': 'Czeka na akceptację: {name}',
  'Nothing waiting for your review': 'Nic nie czeka na Twoją akceptację',
  'AMY will let you know when new posts are ready.': 'AMY da znać, gdy nowe posty będą gotowe.',
  '{network} needs reconnecting': '{network} wymaga ponownego połączenia',
  '{name} can reconnect it in Settings': '{name} może połączyć ponownie w Ustawieniach',
  '{ok} of {n} channels working': 'Działa {ok} z {n} kanałów',
  'Reconnect {network}': 'Połącz ponownie {network}',
  'All channels connected': 'Wszystkie kanały połączone',
  'Calendar view': 'Widok kalendarza',
  'Previous month': 'Poprzedni miesiąc',
  'Next month': 'Następny miesiąc',
  'All channels are hidden. Choose at least one channel above.':
    'Wszystkie kanały są ukryte. Wybierz powyżej co najmniej jeden.',
  'Nothing planned for this week yet': 'Na ten tydzień nic jeszcze nie zaplanowano',
  'AMY plans new weeks from your campaigns. You can also ask for something specific.':
    'AMY planuje kolejne tygodnie na podstawie kampanii. Możesz też poprosić o coś konkretnego.',
  'Please plan posts for the week of {date}.': 'Zaplanuj proszę posty na tydzień od {date}.',
  'Ask AMY to plan this week': 'Poproś AMY o plan na ten tydzień',
  'Left empty on purpose': 'Celowo puste',
  'Open the week of {date}': 'Otwórz tydzień od {date}',
  '+{n} more': '+{n} więcej',
  'Daily allowance today': 'Dzienny limit na dziś',
  'one post per channel per day': 'jeden post na kanał dziennie',
  'reconnect first': 'najpierw połącz ponownie',
  'Nothing posted': 'Nic nie opublikowano',
  'Approved. “{title}” is scheduled.': 'Zaakceptowano. „{title}” jest zaplanowany.',
  'Task · {status}': 'Zadanie · {status}',
  'demo, no real AI yet': 'demo, bez prawdziwej AI',
  Queued: 'W kolejce',
  Working: 'W toku',
  Ready: 'Gotowe',
  Yesterday: 'Wczoraj',
  'Good morning, Anna! Six posts are ready for your review, including the gingerbread latte for Thursday.':
    'Dzień dobry, Anno! Sześć postów czeka na Twoją akceptację, w tym piernikowe latte na czwartek.',
  'Done. The Instagram Reel is ready for Thursday 19 November at 9:00, with Facebook and TikTok versions.':
    'Gotowe. Rolka na Instagram jest przygotowana na czwartek 19 listopada o 9:00, razem z wersjami na Facebook i TikTok.',
  'The winter menu plan runs from 16 to 29 November. Five posts are waiting for your review.':
    'Plan menu zimowego obejmuje 16–29 listopada. Pięć postów czeka na Twoją akceptację.',
  'Yes. I will add it on Friday 27 November when I prepare the next batch.':
    'Tak. Dodam go na piątek 27 listopada, gdy będę przygotowywać kolejną partię.',
  'Add a cinnamon buns post to the winter menu': 'Dodać post o cynamonkach do menu zimowego',
  'I brightened the photo and made the opening line warmer, as you asked.':
    'Rozjaśniłam zdjęcie i ociepliłam pierwsze zdanie, tak jak prosiłaś.',
  'Dzień dobry! Pierogi Thursday and the Friday jazz evening are ready for your review.':
    'Dzień dobry! Pierogowy czwartek i piątkowy wieczór jazzowy czekają na Twoją akceptację.',
  'Got it. I have added this as a task and will tell you here when a draft is ready for review.':
    'Jasne. Dodałam to jako zadanie i dam znać tutaj, gdy szkic będzie gotowy do akceptacji.',
  'The new version is ready. Have a look when you have a moment.':
    'Nowa wersja jest gotowa. Zajrzyj, gdy znajdziesz chwilę.',
  '{name} approved “{title}” ({channel}). It is scheduled.':
    '{name} zaakceptował(a) „{title}” ({channel}). Post jest zaplanowany.',
  '{name} asked for changes to “{title}”: {text}': '{name} prosi o zmiany w „{title}”: {text}',
  '{name} rejected “{title}”. AMY is preparing a different idea for the same slot.':
    '{name} odrzucił(a) „{title}”. AMY przygotowuje inny pomysł na to samo miejsce.',
  '{name} rejected “{title}”. The slot stays empty.':
    '{name} odrzucił(a) „{title}”. Miejsce pozostaje puste.',
  '{name} rejected “{title}”. The slot is on hold until someone decides.':
    '{name} odrzucił(a) „{title}”. Miejsce czeka na decyzję.',
  '{name} stopped “{title}” ({channel}). It stays on hold until someone resumes or reschedules it.':
    '{name} zatrzymał(a) „{title}” ({channel}). Post czeka, aż ktoś go wznowi lub przełoży.',
  '{name} resumed “{title}”.': '{name} wznowił(a) „{title}”.',
  '{name} paused all publishing.': '{name} wstrzymał(a) całe publikowanie.',
  '{name} resumed publishing.': '{name} wznowił(a) publikowanie.',
  '{name} applied brand guide v{v}. AMY uses it for new content from now on.':
    '{name} zastosował(a) przewodnik marki v{v}. Od teraz AMY korzysta z niego w nowych treściach.',
  '{title}: new version ready for review': '{title}: nowa wersja gotowa do akceptacji',
  '{title} is ready for your review': '{title} czeka na Twoją akceptację',
  '{title}: published on {ok} of {n} accounts': '{title}: opublikowano na {ok} z {n} kont',
  'Version {n} ready': 'Wersja {n} gotowa',
  'Draft created': 'Utworzono szkic',
  'Approved and scheduled': 'Zaakceptowano i zaplanowano',
  'Asked for changes: {text}': 'Prośba o zmiany: {text}',
  'Rejected · AMY prepares a different idea': 'Odrzucono · AMY przygotowuje inny pomysł',
  'Rejected · slot left empty': 'Odrzucono · miejsce pozostaje puste',
  'Rejected · decide later': 'Odrzucono · decyzja później',
  'Replacement for “{title}”': 'Zamiennik dla „{title}”',
  'Stopped before publishing': 'Zatrzymano przed publikacją',
  'Resumed at the original time': 'Wznowiono w pierwotnym terminie',
  'A new idea for this slot.': 'Nowy pomysł na to miejsce.',
  'Retried after the earlier revision failed.': 'Ponowiono po nieudanej poprawce.',
  'Brightened the photo and made the opening line warmer.':
    'Rozjaśniono zdjęcie i ocieplono pierwsze zdanie.',
  'Three short video clips (5–10 s) of latte art being poured.':
    'Trzy krótkie klipy (5–10 s) pokazujące nalewanie latte art.',
  Rejected: 'Odrzucono',
  'Every day': 'Codziennie',
  'Autumn at Lipa': 'Jesień w Lipie',
  Events: 'Wydarzenia',
  'Your creative library for {ws}': 'Twoja biblioteka materiałów: {ws}',
  'Nothing is missing right now.': 'Niczego teraz nie brakuje.',
  'For “{title}”, please use photos instead of video.':
    'W „{title}” użyj proszę zdjęć zamiast wideo.',
  'Next prototype round': 'Kolejna runda prototypu',
  'This view is planned but not built in the prototype yet. Nothing was changed or sent.':
    'Ten widok jest zaplanowany, ale nie ma go jeszcze w prototypie. Nic nie zostało zmienione ani wysłane.',
  OK: 'OK',
  'Invitation prepared for {name}. In this demo nothing is sent.':
    'Przygotowano zaproszenie dla: {name}. W tym demo nic nie jest wysyłane.',
  'A few quick steps to get {ws} ready · {n} of 7 done':
    'Kilka szybkich kroków, by przygotować {ws} · ukończono {n} z 7',
  'Demo: the key is checked only in this browser and never sent anywhere. Try a key containing "fail" or "billing" to see error states.':
    'Demo: klucz jest sprawdzany tylko w tej przeglądarce i nigdzie nie trafia. Wpisz klucz zawierający „fail” lub „billing”, aby zobaczyć komunikaty o błędach.',
  'Paste your API key first.': 'Najpierw wklej klucz API.',
  'This key looks too short. Copy the whole key from {provider}.':
    'Ten klucz wygląda na za krótki. Skopiuj cały klucz z {provider}.',
  '{provider} did not accept this key. Create a new key and try again.':
    '{provider} nie przyjął tego klucza. Utwórz nowy klucz i spróbuj ponownie.',
  'The key works, but {provider} needs a payment method first. Open billing, add a card, then test again.':
    'Klucz działa, ale {provider} wymaga najpierw metody płatności. Otwórz płatności, dodaj kartę i sprawdź ponownie.',
  'Approved. “{title}” is scheduled for {when} at {time}.':
    'Zaakceptowano. „{title}” zaplanowano na {when}, {time}.',
  'Sent to AMY. The new version will appear here when it is ready.':
    'Wysłano do AMY. Nowa wersja pojawi się tutaj, gdy będzie gotowa.',
  'Rejected. AMY is preparing a different idea for this slot.':
    'Odrzucono. AMY przygotowuje inny pomysł na to miejsce.',
  'Rejected. The slot stays empty.': 'Odrzucono. Miejsce pozostaje puste.',
  'Rejected. The slot waits for your decision.': 'Odrzucono. Miejsce czeka na Twoją decyzję.',
  'Stopped. It will not be published until someone resumes it.':
    'Zatrzymano. Post nie zostanie opublikowany, dopóki ktoś go nie wznowi.',
  '{name} approves posts for {ws}': 'Posty dla {ws} akceptuje: {name}',
  'Post details': 'Szczegóły posta',
  '{i} of {n} · {posts} waiting for review': '{i} z {n} · czeka na akceptację: {posts}',
  'Document · {n} pages': 'Dokument · stron: {n}',
  'Page {i} of {n}': 'Strona {i} z {n}',
  'Previous page': 'Poprzednia strona',
  'Next page': 'Następna strona',
  'Previous slide': 'Poprzedni slajd',
  'Next slide': 'Następny slajd',
  'Read the caption': 'Przeczytaj opis',
  'Versions of this post': 'Wersje tego posta',
  'Content language: {lang}': 'Język treści: {lang}',
  'Version {n}': 'Wersja {n}',
  'What changed in version {n}': 'Co się zmieniło w wersji {n}',
  Activity: 'Aktywność',
  'Stop this post': 'Zatrzymaj ten post',
  'Only {name} can stop scheduled posts': 'Zaplanowane posty może zatrzymać tylko: {name}',
  'Request a revision': 'Poproś o poprawkę',
  'Resumed. It is scheduled again for {when} at {time}.':
    'Wznowiono. Post jest ponownie zaplanowany na {when}, {time}.',
  'Resume at the original time': 'Wznów w pierwotnym terminie',
  'Please find a new time for “{title}” ({channel}).':
    'Znajdź proszę nowy termin dla „{title}” ({channel}).',
  'Ask AMY for a new time': 'Poproś AMY o nowy termin',
  'About “{title}” on {when}: ': 'W sprawie „{title}” ({when}): ',
  'Tell AMY something about this post': 'Napisz AMY coś o tym poście',
  'Please move “{title}” to another time.': 'Przenieś proszę „{title}” na inny termin.',
  'Suggest a different time': 'Zaproponuj inny termin',
  'Add the material': 'Dodaj materiał',
  'Please suggest a new idea for {channel} on {when}.':
    'Zaproponuj proszę nowy pomysł na {channel} na {when}.',
  'Ask AMY for an idea': 'Poproś AMY o pomysł',
  'Decide later': 'Zdecyduję później',
  'Stop this post?': 'Zatrzymać ten post?',
  '“{title}” will not be published on {when} at {time}. It stays on hold until someone resumes it or asks for a new time.':
    '„{title}” nie zostanie opublikowany {when} o {time}. Post czeka, aż ktoś go wznowi lub poprosi o nowy termin.',
  'Only the {channel} version stops. The other versions stay scheduled.':
    'Zatrzymuje się tylko wersja na {channel}. Pozostałe wersje są nadal zaplanowane.',
  'Stop post': 'Zatrzymaj post',
  'Keep it scheduled': 'Zostaw zaplanowany',
  'Published at {time} · demo result, no real post':
    'Opublikowano o {time} · wynik demonstracyjny, bez prawdziwego posta',
  'Reach after 24 hours (simulated): {n}': 'Zasięg po 24 godzinach (symulacja): {n}',
  'Publishing is paused. This post waits until publishing is resumed.':
    'Publikowanie jest wstrzymane. Ten post czeka na wznowienie.',
  'Scheduled. You can still stop it or ask for a revision before it goes out.':
    'Zaplanowano. Przed publikacją możesz go jeszcze zatrzymać albo poprosić o poprawkę.',
  'Stopped. Its time has passed, so ask AMY for a new time if you still want it.':
    'Zatrzymano. Termin minął, więc jeśli nadal chcesz ten post, poproś AMY o nowy.',
  'Stopped and on hold. It will not be published until someone resumes it.':
    'Zatrzymano i wstrzymano. Post nie zostanie opublikowany, dopóki ktoś go nie wznowi.',
  'AMY is preparing version {n}…': 'AMY przygotowuje wersję {n}…',
  'You will get a notification when it is ready to review.':
    'Dostaniesz powiadomienie, gdy będzie gotowa do akceptacji.',
  'Planned. AMY writes the first draft about three days before it is due.':
    'Zaplanowano. AMY pisze pierwszy szkic około trzech dni przed terminem.',
  'AMY needs material for this post': 'AMY potrzebuje materiału do tego posta',
  'This slot was left empty on purpose. Nothing will be published.':
    'To miejsce celowo zostawiono puste. Nic nie zostanie opublikowane.',
  'This idea was rejected and will not be published.':
    'Ten pomysł odrzucono i nie zostanie opublikowany.',
  'Post not found': 'Nie znaleziono posta',
  'This post is no longer available': 'Ten post nie jest już dostępny',
  'Nothing else needs your review right now. Approved posts are on the calendar.':
    'Nic więcej nie czeka teraz na akceptację. Zaakceptowane posty są w kalendarzu.',
  'It may have been removed or replaced.': 'Mógł zostać usunięty lub zastąpiony.',
  'Not published': 'Nie opublikowano',
  'Marek has not connected his LinkedIn account yet.':
    'Marek nie połączył jeszcze swojego konta LinkedIn.',
  'Sample figures': 'Przykładowe dane',
  'Other versions keep their approval and schedule.':
    'Pozostałe wersje zachowują akceptację i termin.',
  'Only {name} can change this': 'Może to zmienić tylko: {name}',
  '{name} can approve content for publishing.': '{name} może akceptować treści do publikacji.',
  '{name} can review and comment, but cannot approve.':
    '{name} może przeglądać i komentować, ale nie może akceptować.',
  '{name} can stop a scheduled post.': '{name} może zatrzymać zaplanowany post.',
  '{name} cannot stop scheduled posts.': '{name} nie może zatrzymywać zaplanowanych postów.',
  'Connected by {name}': 'Połączył(a): {name}',
  'Profile reconnected (simulated)': 'Profil połączono ponownie (symulacja)',
  'Nothing is published while paused. {n} scheduled posts would wait.':
    'W czasie przerwy nic nie jest publikowane. Zaplanowane posty, które by czekały: {n}.',
  'Publishing paused for {ws}.': 'Wstrzymano publikowanie dla {ws}.',
  'Publishing paused by {name}': 'Publikowanie wstrzymał(a): {name}',
  'Profile connected (simulated)': 'Profil połączony (symulacja)',
  'Message sent to Hakusana. They usually reply within one working day.':
    'Wiadomość wysłana do Hakusana. Zwykle odpowiadają w ciągu jednego dnia roboczego.',
  'You are all caught up.': 'Wszystko na bieżąco.',
  'Message Hakusana': 'Napisz do Hakusana',
  'Your agency team sees this together with {ws}.':
    'Zespół agencji zobaczy tę wiadomość razem z przestrzenią {ws}.',
  'Your message': 'Twoja wiadomość',
  'For example: can we plan posts for our Christmas opening hours?':
    'Na przykład: czy możemy zaplanować posty o świątecznych godzinach otwarcia?',
  'Send message': 'Wyślij wiadomość',
  'Search {ws}': 'Szukaj: {ws}',
  'Nothing matches “{q}” in {ws}.': 'Brak wyników dla „{q}” w {ws}.',
  Posts: 'Posty',
  Materials: 'Materiały',
  Conversations: 'Rozmowy',
  Pages: 'Strony',
  'Open it from the AMY chat': 'Otwórz w czacie z AMY',
  'Mark all as read': 'Oznacz wszystko jako przeczytane',
  'Reset demo data': 'Przywróć dane demonstracyjne',
  'Sign out is not part of this demo': 'Wylogowanie nie jest częścią tego demo',
  'Client owner': 'Właściciel konta klienta',
  'Client contributor': 'Współpracownik klienta',
  'Agency staff': 'Zespół agencji',
  'Platform admin': 'Administrator platformy',
  'AI usage details': 'Szczegóły użycia AI',
  'Add or replace a brand file': 'Dodawanie lub wymiana pliku marki',
  'Add, edit or remove a colour': 'Dodawanie, edycja i usuwanie kolorów',
  'Attach photos, videos or documents': 'Załączanie zdjęć, filmów i dokumentów',
  'Campaign details': 'Szczegóły kampanii',
  'Cancel an upload': 'Anulowanie przesyłania',
  'Choose a font from Google Fonts': 'Wybór czcionki z Google Fonts',
  'Choose material for this change': 'Wybór materiału do tej zmiany',
  'Configure the Social Media module': 'Konfiguracja modułu mediów społecznościowych',
  'Create a campaign': 'Tworzenie kampanii',
  'Edit media limits': 'Edycja limitów multimediów',
  'Export a report': 'Eksport raportu',
  'Incident details': 'Szczegóły incydentu',
  'Invite a contributor': 'Zapraszanie współpracownika',
  'Invite someone to connect their personal LinkedIn':
    'Zaproszenie do połączenia osobistego konta LinkedIn',
  'Manage a connected account': 'Zarządzanie połączonym kontem',
  'Manage an agency': 'Zarządzanie agencją',
  'Suggest a brand change': 'Propozycja zmiany marki',
  'Upload clips for this post': 'Przesyłanie klipów do tego posta',
  'Upload photos, videos or audio': 'Przesyłanie zdjęć, filmów i nagrań',
  TikTok: 'TikTok',
  '{status} · reconnect {network}': '{status} · połącz ponownie {network}',
  '{network} needs reconnecting before this can be published':
    '{network} wymaga ponownego połączenia przed publikacją',
  'The approval is kept. Reconnect {account} and the post goes out as planned; if the time passes first, AMY asks for a new time.':
    'Akceptacja pozostaje. Połącz ponownie {account}, a post wyjdzie zgodnie z planem; jeśli termin minie wcześniej, AMY zapyta o nowy.',
  'You can still approve it. It will only be published once {account} is reconnected.':
    'Nadal możesz go zaakceptować. Zostanie opublikowany dopiero po ponownym połączeniu {account}.',
  'The {channel} slot on {when} is now taken by another post. Ask AMY for a new time instead.':
    'Miejsce na {channel} ({when}) zajmuje już inny post. Poproś AMY o nowy termin.',
  'Only the {channel} version stops. Other versions keep their current status.':
    'Zatrzymuje się tylko wersja na {channel}. Pozostałe wersje zachowują obecny status.',
  Build: 'Wersja',
  'Build being tested': 'Testowana wersja',
  'Colour added: {name}': 'Dodano kolor: {name}',
  'Colour changed: {name}': 'Zmieniono kolor: {name}',
  'Colour removed: {name}': 'Usunięto kolor: {name}',
  '{family} set for {role} in the draft': 'W szkicu ustawiono {family} dla: {role}',
  '{role} need a font. Choose a replacement for {family}.':
    '{role} potrzebują czcionki. Wybierz zamiennik dla {family}.',
  '{family} removed from the draft': 'Usunięto {family} ze szkicu',
  '{name} removed from the draft': 'Usunięto {name} ze szkicu',
  'Replaced in the draft. Approved posts keep the previous file.':
    'Zastąpiono w szkicu. Zaakceptowane posty zachowują poprzedni plik.',
  'Removed from the brand draft. The file stays in its original place.':
    'Usunięto ze szkicu marki. Plik zostaje w swoim miejscu.',
  'You are editing a draft{by}. Changes save automatically; AMY keeps using v{v} until the draft is applied.':
    'Edytujesz szkic{by}. Zmiany zapisują się automatycznie; do czasu zatwierdzenia AMY korzysta z v{v}.',
  Edit: 'Edytuj',
  'Saved to the brand draft': 'Zapisano w szkicu marki',
  'Save to draft': 'Zapisz w szkicu',
  Replace: 'Zastąp',
  'Edit {name}': 'Edytuj: {name}',
  Change: 'Zmień',
  Remove: 'Usuń',
  'Add a photo guideline': 'Dodaj wskazówkę dotyczącą zdjęć',
  'Add a logo rule': 'Dodaj zasadę dotyczącą logo',
  'Rules for each language AMY writes in. The app language does not change your content.':
    'Zasady dla każdego języka, w którym pisze AMY. Język aplikacji nie zmienia Twoich treści.',
  'Notes for {lang}': 'Wskazówki dla: {lang}',
  'Add example': 'Dodaj przykład',
  'Saved as a proposed brand rule in the draft': 'Zapisano w szkicu jako proponowaną zasadę marki',
  'Make this a brand rule': 'Ustaw jako zasadę marki',
  'v{v} copied into a new draft. Review and apply it to use it again.':
    'Skopiowano v{v} do nowego szkicu. Sprawdź i zatwierdź, aby znów jej używać.',
  'Restore as draft': 'Przywróć jako szkic',
  'What should the post be about? (optional)': 'O czym ma być post? (opcjonalnie)',
  'For example: Saturday coffee tasting': 'Na przykład: sobotnia degustacja kawy',
  'Sample preview · not a scheduled post': 'Przykładowy podgląd · to nie jest zaplanowany post',
  'Draft v{v} · changes: {n}': 'Szkic v{v} · zmiany: {n}',
  'Review changes': 'Sprawdź zmiany',
  'Saved automatically': 'Zapisano automatycznie',
  'Why it is a good example': 'Dlaczego to dobry przykład',
  'Example removed from the draft': 'Usunięto przykład ze szkicu',
  'Remove example': 'Usuń przykład',
  'Add a good example': 'Dodaj dobry przykład',
  'Published post': 'Opublikowany post',
  'Why is it a good example?': 'Dlaczego to dobry przykład?',
  'For example: short, warm and shows real guests':
    'Na przykład: krótki, ciepły i pokazuje prawdziwych gości',
  'Example added to the draft': 'Dodano przykład do szkicu',
  'Add to draft': 'Dodaj do szkicu',
  'Draft by {name}': 'Szkic: {name}',
  'What is it for?': 'Do czego służy?',
  'Any background': 'Dowolne tło',
  'Usage note (optional)': 'Uwagi dotyczące użycia (opcjonalnie)',
  'For example: profile pictures': 'Na przykład: zdjęcia profilowe',
  Source: 'Źródło',
  'Remove from brand': 'Usuń z marki',
  'AMY stops using this file for new posts. The file itself is not deleted.':
    'AMY przestanie używać tego pliku w nowych postach. Sam plik nie zostanie usunięty.',
  'Saved to the brand draft. Approved posts keep their colours.':
    'Zapisywane w szkicu marki. Zaakceptowane posty zachowują swoje kolory.',
  'Enter a HEX code to preview': 'Wpisz kod HEX, aby zobaczyć podgląd',
  'Pick a colour': 'Wybierz kolor',
  'Use six characters after #, for example #365A48.':
    'Użyj sześciu znaków po #, na przykład #365A48.',
  '{name} already uses this colour. You can still save it with another role.':
    'Ten kolor ma już {name}. Nadal możesz go zapisać z inną rolą.',
  'For example: Forest green': 'Na przykład: leśna zieleń',
  'Another colour already has this name.': 'Inny kolor ma już tę nazwę.',
  Role: 'Rola',
  'When to use it (optional)': 'Kiedy go używać (opcjonalnie)',
  'For example: offer badges only': 'Na przykład: tylko plakietki z ofertą',
  'Remove {name} from the brand draft? Readability checks that use it are removed too.':
    'Usunąć {name} ze szkicu marki? Kontrole czytelności z tym kolorem też zostaną usunięte.',
  'Remove colour': 'Usuń kolor',
  'From the Google Fonts library': 'Z biblioteki Google Fonts',
  'Search font families': 'Szukaj krojów pisma',
  Show: 'Pokaż',
  'Supports Polish letters': 'Obsługuje polskie litery',
  'Preview text': 'Tekst podglądu',
  'Demo catalogue: {n} of {total}+ Google Fonts families. The live app searches the full library.':
    'Katalog demo: {n} z ponad {total} krojów Google Fonts. Wersja produkcyjna przeszukuje całą bibliotekę.',
  'No fonts match. Try another name or category.':
    'Brak pasujących czcionek. Spróbuj innej nazwy lub kategorii.',
  'No Polish letters': 'Bez polskich liter',
  'Use this font for': 'Użyj tej czcionki do',
  '{file} is not a supported type here.': 'Ten typ pliku nie jest tutaj obsługiwany: {file}.',
  'Choose from your phone or computer': 'Wybierz z telefonu lub komputera',
  'Photos, videos, audio and documents. No small size limits: AMY keeps an optimised copy for your posts.':
    'Zdjęcia, filmy, nagrania i dokumenty. Bez małych limitów rozmiaru: AMY zachowuje zoptymalizowaną kopię do Twoich postów.',
  'Demo: only small photos are previewed in this browser; nothing is uploaded to a server.':
    'Demo: w tej przeglądarce widać podgląd tylko małych zdjęć; nic nie jest wysyłane na serwer.',
  'The Material bank is empty.': 'Materiały są puste.',
  'Linked folder': 'Połączony folder',
  '{n} files': 'Pliki: {n}',
  'This folder is empty.': 'Ten folder jest pusty.',
  'Files stay in your Drive. AMY only prepares a copy of the files you use.':
    'Pliki zostają na Twoim Dysku. AMY przygotowuje kopię tylko tych, których używasz.',
  'Selected: {n}': 'Wybrano: {n}',
  'Nothing selected yet': 'Nic jeszcze nie wybrano',
  'Use selected': 'Użyj wybranych',
  'Change font': 'Zmień czcionkę',
  'Add a font': 'Dodaj czcionkę',
  Recommended: 'Polecane',
  'All fonts': 'Wszystkie czcionki',
  All: 'Wszystkie',
  'Sans serif': 'Bezszeryfowe',
  Serif: 'Szeryfowe',
  Display: 'Ozdobne',
  Handwriting: 'Odręczne',
  Monospace: 'O stałej szerokości',
  Loaded: 'Wczytano',
  'Loading…': 'Wczytywanie…',
  'Could not load, showing a fallback': 'Nie udało się wczytać, widać zamiennik',
  'Replace in draft': 'Zastąp w szkicu',
  'Add to brand draft': 'Dodaj do szkicu marki',
  'Edit colour': 'Edytuj kolor',
  'Add a colour': 'Dodaj kolor',
  '{name} updated in the draft': 'Zaktualizowano {name} w szkicu',
  '{name} added to the draft': 'Dodano {name} do szkicu',
  'Add a brand file': 'Dodaj plik marki',
  'Replace a brand file': 'Zastąp plik marki',
  'Edit brand file': 'Edytuj plik marki',
  'Brand reference': 'Materiał referencyjny marki',
  Upload: 'Prześlij',
  'Google Drive': 'Dysk Google',
  'Choose one or more files': 'Wybierz jeden lub więcej plików',
  'Choose one file': 'Wybierz jeden plik',
  Document: 'Dokument',
  'Linked from Drive': 'Z Dysku Google',
  Menu: 'Menu',
  'Shared folder': 'Udostępniony folder',
  'Step {n} of 2': 'Krok {n} z 2',
  'AMY asks for read-only access to one folder. It cannot change or delete anything in your Drive.':
    'AMY prosi o dostęp tylko do odczytu do jednego folderu. Nie może niczego zmienić ani usunąć na Twoim Dysku.',
  'What should AMY use?': 'Czego AMY ma używać?',
  'A folder in my Drive': 'Folder na moim Dysku',
  'Signed in as {account}': 'Zalogowano jako {account}',
  'Folder name': 'Nazwa folderu',
  'A shared folder link': 'Link do udostępnionego folderu',
  'For a folder someone else owns, like your photographer.':
    'Dla folderu, którego właścicielem jest ktoś inny, np. Twój fotograf.',
  'Folder link': 'Link do folderu',
  'This does not look like a Google Drive folder link.':
    'To nie wygląda na link do folderu Dysku Google.',
  'Check access': 'Sprawdź dostęp',
  'Disconnect Drive': 'Odłącz Dysk',
  'AMY stops listing Drive files. Photos already used in posts stay in those posts.':
    'AMY przestanie wyświetlać pliki z Dysku. Zdjęcia użyte już w postach pozostaną w tych postach.',
  'Google Drive disconnected': 'Dysk Google odłączony',
  Disconnect: 'Odłącz',
  'AMY can open “{folder}”: {n} files in {f} folders.':
    'AMY ma dostęp do „{folder}”: {n} plików w {f} folderach.',
  'What AMY will see': 'Co zobaczy AMY',
  'Only this folder and the folders inside it.': 'Tylko ten folder i foldery w nim.',
  'Files are listed, not copied. AMY prepares a copy only when a file is used in a post.':
    'Pliki są tylko wyświetlane, nie kopiowane. AMY przygotowuje kopię dopiero, gdy plik zostanie użyty w poście.',
  'New files show up when the folder is checked, at least once a day.':
    'Nowe pliki pojawiają się po sprawdzeniu folderu, co najmniej raz dziennie.',
  'Google Drive connected: {folder}': 'Połączono Dysk Google: {folder}',
  'Connect this folder': 'Połącz ten folder',
  'Folder path': 'Ścieżka folderu',
  '{n} files in this folder': 'Plików w tym folderze: {n}',
  'Show more ({n} left)': 'Pokaż więcej (zostało {n})',
  'Choose files to add to the Material bank': 'Wybierz pliki do dodania do Banku materiałów',
  '{n} already in the library': 'już w bibliotece: {n}',
  '{n} files linked. AMY is preparing them for posts.':
    'Połączono pliki: {n}. AMY przygotowuje je do postów.',
  'These files are already in the library.': 'Te pliki są już w bibliotece.',
  'Add to Material bank': 'Dodaj do Banku materiałów',
  '{n} files added to the upload queue': 'Dodano pliki do kolejki przesyłania: {n}',
  'AMY can no longer open this folder. Ask the folder owner to share it again, or choose another folder.':
    'AMY nie ma już dostępu do tego folderu. Poproś właściciela o ponowne udostępnienie albo wybierz inny folder.',
  'Linked folder · {n} files · checked at {time}':
    'Połączony folder · {n} plików · sprawdzono o {time}',
  Browse: 'Przeglądaj',
  'Folder checked. {n} files, nothing new.': 'Folder sprawdzony. {n} plików, nic nowego.',
  Refresh: 'Odśwież',
  'Access restored (simulated)': 'Dostęp przywrócony (symulacja)',
  'Fix access': 'Napraw dostęp',
  'Demo only': 'Tylko w wersji demo',
  'Simulate lost access': 'Symuluj utratę dostępu',
  'Change folder': 'Zmień folder',
  'Use your Google Drive as a library': 'Używaj Dysku Google jako biblioteki',
  'Link one folder. AMY lists the files and only copies the ones you use in posts. Nothing is imported in bulk.':
    'Połącz jeden folder. AMY wyświetla pliki i kopiuje tylko te, których użyjesz w postach. Nic nie jest importowane hurtowo.',
  'Connect a folder': 'Połącz folder',
  'AMY needs material': 'AMY potrzebuje materiałów',
  'Add clips': 'Dodaj klipy',
  'Search names and tags': 'Szukaj nazw i tagów',
  'Show archived': 'Pokaż zarchiwizowane',
  Tags: 'Tagi',
  Favourite: 'Ulubione',
  'Uploading and preparing are separate steps. You can close the app while files prepare.':
    'Przesyłanie i przygotowanie to osobne kroki. Możesz zamknąć aplikację, gdy pliki się przygotowują.',
  'Nothing uploading right now.': 'Teraz nic się nie przesyła.',
  'Finished ({n})': 'Zakończone ({n})',
  'You can keep using the app.': 'Możesz dalej korzystać z aplikacji.',
  'Simulate drop': 'Symuluj zerwanie',
  'Keep both': 'Zachowaj oba',
  Dismiss: 'Odrzuć',
  Renamed: 'Zmieniono nazwę',
  Rename: 'Zmień nazwę',
  'Add a tag': 'Dodaj tag',
  Status: 'Status',
  'Ready for posts': 'Gotowe do postów',
  'Good for': 'Pasuje do',
  'Not used in any post yet.': 'Jeszcze nie użyto w żadnym poście.',
  'Restored to the library': 'Przywrócono do biblioteki',
  Restore: 'Przywróć',
  Archive: 'Archiwizuj',
  'It is used in {n} posts. Those posts keep their copy; AMY just stops suggesting it.':
    'Plik jest użyty w postach: {n}. Te posty zachowają swoją kopię; AMY po prostu przestanie go proponować.',
  'AMY stops suggesting it. You can restore it from “Show archived”.':
    'AMY przestanie go proponować. Możesz go przywrócić w „Pokaż zarchiwizowane”.',
  Archived: 'Zarchiwizowano',
  'with files: {names}': 'z plikami: {names}',
  'AMY uses these files for the new version.': 'AMY użyje tych plików w nowej wersji.',
  Uploading: 'Przesyłanie',
  'Preparing for posts': 'Przygotowanie do postów',
  'Upload stopped': 'Przesyłanie przerwane',
  'Cannot be used': 'Nie można użyć',
  'Already in the Material bank': 'Już w Banku materiałów',
  Cancelled: 'Anulowano',
  'No access': 'Brak dostępu',
  'Paused. Resume any time; it continues where it stopped.':
    'Wstrzymano. Wznów w dowolnej chwili; przesyłanie będzie kontynuowane od miejsca przerwania.',
  'Cancelled. Nothing was added.': 'Anulowano. Nic nie zostało dodane.',
  'This file type cannot be used in posts. Export a JPG, PNG, MP4 or PDF instead.':
    'Tego typu pliku nie można użyć w postach. Wyeksportuj go jako JPG, PNG, MP4 lub PDF.',
  'Already in the Material bank as “{name}”.': 'Już w Banku materiałów jako „{name}”.',
  'The connection dropped at {p}%. Retry continues from where it stopped.':
    'Połączenie zostało przerwane przy {p}%. Ponowienie będzie kontynuowane od miejsca przerwania.',
  'Paused when the phone went to sleep. Resume when you are on Wi-Fi.':
    'Wstrzymano, gdy telefon przeszedł w tryb uśpienia. Wznów, gdy będziesz w sieci Wi-Fi.',
  'Photoshop files cannot be used in posts. Export a JPG or PNG instead.':
    'Plików Photoshopa nie można użyć w postach. Wyeksportuj JPG lub PNG.',
  Reels: 'Rolki',
  Stories: 'Relacje',
  'Feed posts': 'Posty w aktualnościach',
  Carousels: 'Karuzele',
  'LinkedIn documents': 'Dokumenty na LinkedIn',
  'Reels background': 'Tło do rolek',
  'Add more material': 'Dodaj więcej materiałów',
  'Add clips for this post': 'Dodaj klipy do tego posta',
  'Choose photos for this post': 'Wybierz zdjęcia do tego posta',
  'Clips added. AMY is preparing the post and will ask you to review it.':
    'Dodano klipy. AMY przygotowuje post i poprosi Cię o jego sprawdzenie.',
  'Photos chosen. AMY is preparing a carousel and will ask you to review it.':
    'Wybrano zdjęcia. AMY przygotowuje karuzelę i poprosi Cię o jej sprawdzenie.',
  'Zoom in': 'Powiększ',
  'Zoom out': 'Pomniejsz',
  'Add to favourites': 'Dodaj do ulubionych',
  Documents: 'Dokumenty',
  'AMY can no longer open the linked Drive folder. Fix access in the Material bank.':
    'AMY nie ma już dostępu do połączonego folderu na Dysku. Napraw dostęp w Banku materiałów.',
  'Google Drive is not connected for this workspace. Connect a folder in the Material bank.':
    'Dysk Google nie jest połączony z tym obszarem roboczym. Połącz folder w Banku materiałów.',
  'Added clips: {names}': 'Dodano klipy: {names}',
  'Chose photos instead: {names}': 'Wybrano zdjęcia zamiast filmu: {names}',
  '{name} added clips for “{title}”. AMY is preparing it.':
    '{name} dodaje klipy do „{title}”. AMY przygotowuje post.',
  '{name} chose photos instead of video for “{title}”. AMY is preparing a carousel.':
    '{name} wybiera zdjęcia zamiast filmu do „{title}”. AMY przygotowuje karuzelę.',
  'Made with the clips you added.': 'Przygotowano z dodanych klipów.',
  'Rebuilt as a photo carousel with the photos you chose.':
    'Przebudowano jako karuzelę z wybranych zdjęć.',
  'Change Drive folder': 'Zmień folder na Dysku',
  'Connect Google Drive': 'Połącz Dysk Google',
  'No archived files.': 'Brak zarchiwizowanych plików.',
  'No files match these filters.': 'Żaden plik nie pasuje do tych filtrów.',
  'Already in the library': 'Już w bibliotece',
  'Replace the current draft?': 'Zastąpić bieżący szkic?',
  'There is an unapplied draft by {name}. Restoring v{v} replaces it, and its changes are lost.':
    'Jest niezastosowany szkic autorstwa {name}. Przywrócenie v{v} go zastąpi, a jego zmiany zostaną utracone.',
  'Review the draft first': 'Najpierw przejrzyj szkic',
  'Replace draft with v{v}': 'Zastąp szkic wersją v{v}',
  'Keep my draft': 'Zachowaj mój szkic',
  'First brand guide': 'Pierwszy przewodnik marki',
  'Added to the calendar on {day}. AMY is drafting it now.':
    'Dodano do kalendarza na {day}. AMY przygotowuje teraz szkic.',
  '{channel} needs reconnecting before AMY can plan posts for it.':
    '{channel} wymaga ponownego połączenia, zanim AMY zaplanuje na nim posty.',
  'Resume the campaign to add ideas to the calendar.':
    'Wznów kampanię, aby dodawać pomysły do kalendarza.',
  'No free {channel} slot between {from} and {to}. Free a slot or change the campaign dates.':
    'Brak wolnego miejsca na {channel} między {from} a {to}. Zwolnij miejsce lub zmień daty kampanii.',
  'All campaigns': 'Wszystkie kampanie',
  '{n} posts a week': '{n} postów tygodniowo',
  'Campaign chat': 'Czat kampanii',
  'AMY needs an answer': 'AMY potrzebuje odpowiedzi',
  'Your answer': 'Twoja odpowiedź',
  'For example: closed 24–26 December, open 10–14 on 31 December.':
    'Na przykład: zamknięte 24–26 grudnia, 31 grudnia otwarte 10–14.',
  'Thanks. AMY is preparing ideas with your answer.':
    'Dziękujemy. AMY przygotowuje pomysły z uwzględnieniem Twojej odpowiedzi.',
  'Send answer': 'Wyślij odpowiedź',
  'Paused. AMY prepares no new posts for this campaign. Scheduled posts still go out.':
    'Wstrzymano. AMY nie przygotowuje nowych postów do tej kampanii. Zaplanowane posty nadal zostaną opublikowane.',
  'Resume campaign': 'Wznów kampanię',
  'This campaign has ended. Published posts and their results stay here.':
    'Ta kampania się zakończyła. Opublikowane posty i ich wyniki pozostają tutaj.',
  'Next free slots': 'Najbliższe wolne miejsca',
  'none in these dates': 'brak w tych datach',
  'Review {n}': 'Sprawdź ({n})',
  Ideas: 'Pomysły',
  'AMY is suggesting more ideas.': 'AMY proponuje kolejne pomysły.',
  'Resume the campaign first': 'Najpierw wznów kampanię',
  'AMY is reading your brief and brand guide v{v}…':
    'AMY czyta Twój brief i przewodnik marki v{v}…',
  'Add to calendar': 'Dodaj do kalendarza',
  'Not this one': 'Nie ten',
  'In the calendar': 'W kalendarzu',
  'Bring back': 'Przywróć',
  'No posts yet. Accepted ideas appear here and in the calendar.':
    'Jeszcze brak postów. Zaakceptowane pomysły pojawią się tutaj i w kalendarzu.',
  Brief: 'Brief',
  'Materials for AMY': 'Materiały dla AMY',
  'AMY writes with brand guide v{v}. Created by {name}.':
    'AMY pisze zgodnie z przewodnikiem marki v{v}. Utworzono przez: {name}.',
  'AMY tasks for this campaign': 'Zadania AMY w tej kampanii',
  'Campaign paused': 'Kampania wstrzymana',
  'Pause campaign': 'Wstrzymaj kampanię',
  'End campaign': 'Zakończ kampanię',
  'End “{name}”?': 'Zakończyć „{name}”?',
  '{n} posts that are not approved yet will be cancelled and their slots freed.':
    'Niezatwierdzone posty ({n}) zostaną anulowane, a ich miejsca zwolnione.',
  '{n} scheduled posts keep their schedule unless you stop them below.':
    'Zaplanowane posty ({n}) zachowają termin, chyba że zatrzymasz je poniżej.',
  'Published posts and their results stay.': 'Opublikowane posty i ich wyniki pozostaną.',
  'Also stop the {n} scheduled posts': 'Zatrzymaj też zaplanowane posty ({n})',
  'Campaign ended': 'Kampania zakończona',
  'Campaign updated': 'Kampania zaktualizowana',
  'The end date is before the start date.':
    'Data zakończenia jest wcześniejsza niż data rozpoczęcia.',
  'Start from tomorrow or later.': 'Zacznij od jutra lub później.',
  'Step {n} of {total}: {name}': 'Krok {n} z {total}: {name}',
  'What is this campaign for?': 'Czemu służy ta kampania?',
  'Campaign name': 'Nazwa kampanii',
  'For example: Hot chocolate launch': 'Na przykład: Premiera gorącej czekolady',
  'A campaign with this name already exists.': 'Kampania o tej nazwie już istnieje.',
  'When and where?': 'Kiedy i gdzie?',
  'No end date (always-on)': 'Bez daty zakończenia (stała)',
  Start: 'Początek',
  End: 'Koniec',
  Channels: 'Kanały',
  '{status}: AMY can plan, but nothing is published until it is reconnected.':
    '{status}: AMY może planować, ale nic nie zostanie opublikowane do czasu ponownego połączenia.',
  'Choose at least one channel.': 'Wybierz co najmniej jeden kanał.',
  'Posts per week: {n}': 'Postów tygodniowo: {n}',
  'About {w} posts are needed, but only {f} channel slots are free in these dates. AMY fills what fits; free slots or extend the dates for more.':
    'Potrzeba około {w} postów, ale w tych datach wolnych miejsc jest tylko {f}. AMY wypełni to, co się zmieści; zwolnij miejsca lub wydłuż daty, aby dodać więcej.',
  'About {w} posts fit into {f} free channel slots between {from} and {to}.':
    'Około {w} postów zmieści się w {f} wolnych miejscach między {from} a {to}.',
  'Tell AMY what matters': 'Powiedz AMY, co jest ważne',
  'What is new, who it is for, what guests should do. For example: our new hot chocolate, for families on weekends, come to the window seats.':
    'Co jest nowe, dla kogo i co goście mają zrobić. Na przykład: nasza nowa gorąca czekolada, dla rodzin w weekendy, zapraszamy na miejsca przy oknie.',
  'A sentence or two is enough.': 'Wystarczy zdanie lub dwa.',
  'AMY also follows brand guide v{v}.': 'AMY stosuje też przewodnik marki v{v}.',
  'Optional. Without materials AMY uses your Material bank.':
    'Opcjonalnie. Bez materiałów AMY korzysta z Banku materiałów.',
  'Check and start': 'Sprawdź i rozpocznij',
  Goal: 'Cel',
  Dates: 'Daty',
  Rhythm: 'Rytm',
  'From the Material bank': 'Z Banku materiałów',
  'AMY suggests ideas first. Nothing goes into the calendar until you accept an idea, and nothing is published before you approve it.':
    'AMY najpierw proponuje pomysły. Nic nie trafi do kalendarza, dopóki nie zaakceptujesz pomysłu, i nic nie zostanie opublikowane bez Twojej zgody.',
  Next: 'Dalej',
  'Save changes': 'Zapisz zmiany',
  'Save as draft': 'Zapisz jako szkic',
  'Create and ask AMY for ideas': 'Utwórz i poproś AMY o pomysły',
  'planned for {day}': 'zaplanowano na {day}',
  'Open draft': 'Otwórz szkic',
  'This campaign does not exist in this workspace.':
    'Ta kampania nie istnieje w tym obszarze roboczym.',
  Campaigns: 'Kampanie',
  'AMY tasks': 'Zadania AMY',
  'Open campaign: {name}': 'Otwórz kampanię: {name}',
  '{n} published': 'opublikowane: {n}',
  '{n} scheduled': 'zaplanowane: {n}',
  '{n} to review': 'do sprawdzenia: {n}',
  '{n} new ideas': 'nowe pomysły: {n}',
  'No campaigns yet. Start one and AMY suggests the first ideas.':
    'Jeszcze brak kampanii. Utwórz pierwszą, a AMY zaproponuje pomysły.',
  'Everything you or your team asked AMY to do, from chat and campaigns. Demo: AMY’s work is simulated.':
    'Wszystko, o co Ty lub Twój zespół poprosiliście AMY w czacie i kampaniach. Demo: praca AMY jest symulowana.',
  'No tasks here.': 'Brak zadań.',
  'Asked by {name}': 'Zlecone przez: {name}',
  'Planned for {day}': 'Zaplanowano na {day}',
  'Draft {n}': 'Szkic {n}',
  'See ideas': 'Zobacz pomysły',
  'Start now': 'Zacznij teraz',
  'Cancel task': 'Anuluj zadanie',
  'Open in the AMY chat': 'Otwórz w czacie AMY',
  'Launch a product': 'Premiera produktu',
  'A new drink, cake or menu item.': 'Nowy napój, ciasto lub pozycja w menu.',
  'Seasonal menu': 'Menu sezonowe',
  'A few weeks around a season or holiday.': 'Kilka tygodni wokół sezonu lub święta.',
  'Event or opening hours': 'Wydarzenie lub godziny otwarcia',
  'One date to announce, remind and thank.':
    'Jedna data: zapowiedź, przypomnienie i podziękowanie.',
  'Get known locally': 'Bądź znany w okolicy',
  'Introduce the place and the people.': 'Przedstaw miejsce i ludzi.',
  'Everyday content': 'Codzienne treści',
  'No end date. Steady posts every week.': 'Bez daty zakończenia. Regularne posty co tydzień.',
  'Dates and channels': 'Daty i kanały',
  Check: 'Sprawdzenie',
  Planning: 'Planowanie',
  'Ideas ready': 'Pomysły gotowe',
  Finished: 'Zakończona',
  Failed: 'Nie powiodło się',
  'In progress': 'W toku',
  'Which days will you be closed or open shorter between 24 December and 1 January?':
    'W które dni między 24 grudnia a 1 stycznia będzie zamknięte lub krócej otwarte?',
  'Suggest ideas for “{name}”': 'Zaproponuj pomysły do „{name}”',
  'Make a TikTok from the latte art clips': 'Zrób TikToka z klipów latte art',
  'TikTok needs reconnecting, so AMY could not prepare a TikTok version.':
    'TikTok wymaga ponownego połączenia, więc AMY nie mogła przygotować wersji na TikToka.',
  '{channel} needs reconnecting, so AMY could not prepare a {channel} version.':
    '{channel} wymaga ponownego połączenia, więc AMY nie mogła przygotować wersji na {channel}.',
  '{channel} is not connected for this workspace.':
    '{channel} nie jest połączony z tym obszarem roboczym.',
  'No free {channel} slot in the next weeks. Free a slot or allow more posts per day.':
    'Brak wolnego miejsca na {channel} w najbliższych tygodniach. Zwolnij miejsce lub zezwól na więcej postów dziennie.',
  'Made {n} versions for {day}.': 'Przygotowano wersje: {n} na {day}.',
  'Suggested {n} ideas for “{name}”.': 'Zaproponowano pomysły ({n}) do „{name}”.',
  'Draft ready for {day}.': 'Szkic gotowy na {day}.',
  'Noted. AMY will use this for new content.': 'Zanotowano. AMY uwzględni to w nowych treściach.',
  'I have {n} new ideas for “{name}”. Accept the ones you like and I will put them in the calendar.':
    'Mam nowe pomysły ({n}) do „{name}”. Zaakceptuj te, które Ci się podobają, a dodam je do kalendarza.',
  '{name}: {n} new ideas': '{name}: nowe pomysły ({n})',
  'I could not finish “{title}”: {channel} needs reconnecting. Reconnect it in Settings and press Retry on the task.':
    'Nie udało mi się dokończyć „{title}”: {channel} wymaga ponownego połączenia. Połącz go w Ustawieniach i kliknij Ponów przy zadaniu.',
  'There is no free {channel} slot for “{title}”. Free a slot in the calendar and press Retry.':
    'Brak wolnego miejsca na {channel} dla „{title}”. Zwolnij miejsce w kalendarzu i kliknij Ponów.',
  'Here is a draft for “{title}” on {channel}. Have a look when you have a moment.':
    'Oto szkic „{title}” na {channel}. Zajrzyj, gdy znajdziesz chwilę.',
  'Noted. I will keep this in mind for new content.':
    'Zanotowane. Uwzględnię to w nowych treściach.',
  'Got it. I am noting this down.': 'Jasne, zapisuję to.',
  '{name} created the campaign “{title}”.': '{name} tworzy kampanię „{title}”.',
  '{name} answered AMY’s question for “{title}”.': '{name} odpowiada na pytanie AMY do „{title}”.',
  '{name} paused the campaign “{title}”. AMY prepares no new posts for it.':
    '{name} wstrzymuje kampanię „{title}”. AMY nie przygotowuje do niej nowych postów.',
  '{name} resumed the campaign “{title}”.': '{name} wznawia kampanię „{title}”.',
  '{name} ended the campaign “{title}”.': '{name} kończy kampanię „{title}”.',
  'Accepted the idea': 'Zaakceptowano pomysł',
  'First draft ready': 'Pierwszy szkic gotowy',
  'Drafted by AMY': 'Szkic przygotowany przez AMY',
  'Cancelled when the campaign ended': 'Anulowano po zakończeniu kampanii',
  'Stopped when the campaign ended': 'Zatrzymano po zakończeniu kampanii',
  'The first draft from your accepted idea is ready for review.':
    'Pierwszy szkic z zaakceptowanego pomysłu czeka na sprawdzenie.',
  '{title}: first draft ready for review': '{title}: pierwszy szkic do sprawdzenia',
  'Choose material for this campaign': 'Wybierz materiały do tej kampanii',
  'AMY is thinking…': 'AMY myśli…',
  'Ask for more ideas': 'Poproś o więcej pomysłów',
  'Show declined ideas ({n})': 'Pokaż odrzucone pomysły ({n})',
  'Hide declined ideas': 'Ukryj odrzucone pomysły',
  'No new ideas waiting. Ask AMY for more when you need them.':
    'Brak nowych pomysłów. Poproś AMY o kolejne, gdy będą potrzebne.',
  'No ideas yet. Ask AMY for the first ones.': 'Jeszcze brak pomysłów. Poproś AMY o pierwsze.',
  'Edit campaign': 'Edytuj kampanię',
  'Chat with AMY': 'Czat z AMY',
  'Archived only': 'Tylko zarchiwizowane',
  'AMY stops suggesting it. You can restore it from “Archived only”.':
    'AMY przestanie go proponować. Możesz go przywrócić w „Tylko zarchiwizowane”.',
  'File name': 'Nazwa pliku',
  'Colour name': 'Nazwa koloru',
  'Idea sent. AMY is drafting it; follow it under AMY tasks.':
    'Pomysł wysłany. AMY przygotowuje szkic; śledź go w Zadaniach AMY.',
  'Add an idea': 'Dodaj pomysł',
  'Tell AMY in your own words. Nothing is published before you approve it.':
    'Opisz to AMY własnymi słowami. Nic nie zostanie opublikowane bez Twojej zgody.',
  'Your idea': 'Twój pomysł',
  'For example: Saturday coffee tasting with our new Ethiopian beans, 11–13, free for regulars.':
    'Na przykład: sobotnia degustacja kawy z nowymi ziarnami z Etiopii, 11–13, bezpłatnie dla stałych gości.',
  'Suggested date': 'Proponowana data',
  Campaign: 'Kampania',
  'No campaign': 'Bez kampanii',
  '{channels} needs reconnecting. AMY makes the other versions and tells you which one is missing.':
    '{channels} wymaga ponownego połączenia. AMY przygotuje pozostałe wersje i powie, której brakuje.',
  'Task handed to the agency': 'Zadanie przekazane agencji',
  'Open tasks': 'Otwórz zadania',
  'AMY is waiting for the client': 'AMY czeka na klienta',
  'Content creation is paused for this campaign. Resume it to add ideas.':
    'Tworzenie treści w tej kampanii jest wstrzymane. Wznów je, aby dodawać pomysły.',
  'Publishing paused. {n} scheduled posts are held.':
    'Publikowanie wstrzymane. Wstrzymane zaplanowane posty: {n}.',
  'Publishing resumed. {n} posts went back to the schedule; {b} stay held because their slot is taken.':
    'Publikowanie wznowione. Wróciło do harmonogramu: {n}; wstrzymane nadal: {b}, bo ich miejsce jest zajęte.',
  'Publishing resumed. {n} posts went back to the schedule.':
    'Publikowanie wznowione. Wróciło do harmonogramu: {n}.',
  'Creation paused': 'Tworzenie wstrzymane',
  'Publishing paused': 'Publikowanie wstrzymane',
  'Owner: {name}': 'Właściciel: {name}',
  'Waiting for your answer': 'Czeka na Twoją odpowiedź',
  'Thanks. AMY continues with your answer.': 'Dziękujemy. AMY kontynuuje z Twoją odpowiedzią.',
  'Handed to Hakusana. They reply in the conversation.':
    'Przekazano do Hakusany. Odpowiedzą w rozmowie.',
  'Hand to agency': 'Przekaż agencji',
  Plan: 'Plan',
  '{n} posts · {left} not drafted yet': 'Posty: {n} · bez szkicu: {left}',
  'Review the plan. Activating drafts the first two posts as samples; once you approve them, AMY drafts the rest in batches of {n}.':
    'Sprawdź plan. Aktywacja tworzy dwa pierwsze posty jako próbki; po ich zatwierdzeniu AMY przygotuje resztę w partiach po {n}.',
  'Campaign active. AMY is drafting {n} sample posts.':
    'Kampania aktywna. AMY przygotowuje próbne posty: {n}.',
  'Activate campaign': 'Aktywuj kampanię',
  'Samples: approve the {n} sample posts and AMY drafts the next batch automatically.':
    'Próbki: zatwierdź próbne posty ({n}), a AMY automatycznie przygotuje kolejną partię.',
  'AMY is waiting: {n} posts are waiting for your review. The next batch starts when fewer than {limit} are waiting.':
    'AMY czeka: {n} postów czeka na sprawdzenie. Kolejna partia ruszy, gdy będzie ich mniej niż {limit}.',
  'No automatic batches while content creation is paused.':
    'Brak automatycznych partii, gdy tworzenie treści jest wstrzymane.',
  'Next automatic batch: {day} · {n} posts': 'Następna automatyczna partia: {day} · postów: {n}',
  'AMY is drafting {n} posts now.': 'AMY przygotowuje teraz posty: {n}.',
  'No free slots for a new batch.': 'Brak wolnych miejsc na nową partię.',
  'Run it now (demo)': 'Uruchom teraz (demo)',
  Gaps: 'Luki',
  '{from} – {to}: {have} of {need} posts planned':
    '{from} – {to}: zaplanowano {have} z {need} postów',
  'Fill with ideas': 'Uzupełnij pomysłami',
  'Resume content creation first': 'Najpierw wznów tworzenie treści',
  Audience: 'Odbiorcy',
  'Product focus': 'Główne produkty',
  Polish: 'Polski',
  English: 'Angielski',
  Accounts: 'Konta',
  'Saved as a template. It appears in New campaign for this agency.':
    'Zapisano jako szablon. Pojawi się w Nowej kampanii dla tej agencji.',
  'Save as template': 'Zapisz jako szablon',
  Controls: 'Sterowanie',
  'Content creation': 'Tworzenie treści',
  'New ideas, drafts and automatic batches. Pausing does not touch scheduled posts.':
    'Nowe pomysły, szkice i automatyczne partie. Wstrzymanie nie dotyczy zaplanowanych postów.',
  Publishing: 'Publikowanie',
  '{n} scheduled posts. Pausing holds them; nothing is published until you resume.':
    'Zaplanowane posty: {n}. Wstrzymanie je zatrzymuje; nic nie zostanie opublikowane do wznowienia.',
  'Start from a template': 'Zacznij od szablonu',
  Templates: 'Szablony',
  Needs: 'Potrzebne',
  Formats: 'Formaty',
  'Start blank': 'Zacznij od zera',
  'Choose the goal yourself.': 'Wybierz cel samodzielnie.',
  'Choose at least one account.': 'Wybierz co najmniej jedno konto.',
  'Template “{name}” needs': 'Szablon „{name}” potrzebuje',
  'For example: families nearby, weekends': 'Na przykład: rodziny z okolicy, weekendy',
  'For example: hot chocolate, apple cake': 'Na przykład: gorąca czekolada, szarlotka',
  'Choose at least one language.': 'Wybierz co najmniej jeden język.',
  'Help me plan this': 'Pomóż mi to zaplanować',
  'Proposed plan: {n} posts': 'Proponowany plan: postów {n}',
  'Discard the plan': 'Odrzuć plan',
  'AMY understood': 'AMY zrozumiała',
  'Next step': 'Następny krok',
  'Where this post came from': 'Skąd pochodzi ten post',
  'From {name}’s request': 'Z prośby: {name}',
  'See the task': 'Zobacz zadanie',
  Waiting: 'Czeka na odpowiedź',
  'With agency': 'U agencji',
  'Plan ready': 'Plan gotowy',
  'Needs you': 'Czeka na Ciebie',
  'Content creation paused. Scheduled posts still publish.':
    'Tworzenie treści wstrzymane. Zaplanowane posty nadal zostaną opublikowane.',
  'Content creation resumed.': 'Tworzenie treści wznowione.',
  'Resume creation': 'Wznów tworzenie',
  'Pause creation': 'Wstrzymaj tworzenie',
  'Pause publishing': 'Wstrzymaj publikowanie',
  'Add a photo or video (optional)': 'Dodaj zdjęcie lub film (opcjonalnie)',
  'AMY uses the first free slot from this day.':
    'AMY użyje pierwszego wolnego miejsca od tego dnia.',
  'Taken from your text. Change it if needed.': 'Wzięte z Twojego tekstu. Zmień, jeśli trzeba.',
  'Leave empty and AMY picks the next free slot.':
    'Zostaw puste, a AMY wybierze najbliższe wolne miejsce.',
  'Create with this plan': 'Utwórz z tym planem',
  'You review this plan on the campaign page before anything is drafted. Activation drafts two sample posts first.':
    'Plan sprawdzisz na stronie kampanii, zanim powstaną szkice. Aktywacja najpierw tworzy dwa próbne posty.',
  'Product launch': 'Premiera produktu',
  'Tease, launch day, how it is made, last chance.':
    'Zapowiedź, dzień premiery, jak powstaje, ostatnia szansa.',
  'Product name': 'Nazwa produktu',
  'Launch date': 'Data premiery',
  'One photo of the product': 'Jedno zdjęcie produktu',
  Event: 'Wydarzenie',
  'Save the date, what to expect, same-day reminder, thank you.':
    'Zapisz datę, czego się spodziewać, przypomnienie w dniu, podziękowanie.',
  'Event name': 'Nazwa wydarzenia',
  'Date and time': 'Data i godzina',
  'Photo from a past event': 'Zdjęcie z poprzedniego wydarzenia',
  'Team story': 'Historia zespołu',
  'One person, one favourite drink, one short story.':
    'Jedna osoba, jeden ulubiony napój, jedna krótka historia.',
  'Person and role': 'Osoba i rola',
  'A photo of them': 'Jej zdjęcie',
  'Their favourite drink': 'Ulubiony napój',
  Announcement: 'Ogłoszenie',
  'Clear news: opening hours, closures, price changes.':
    'Jasna informacja: godziny otwarcia, zamknięcia, zmiany cen.',
  'From when': 'Od kiedy',
  'Who it affects': 'Kogo dotyczy',
  'What is new': 'Co nowego',
  'One photo': 'Jedno zdjęcie',
  'Plan the holiday opening hours posts': 'Zaplanuj posty o świątecznych godzinach otwarcia',
  'Posts on Instagram and Facebook announcing the holiday opening hours.':
    'Posty na Instagramie i Facebooku z informacją o świątecznych godzinach otwarcia.',
  'Answer the question so AMY can write the posts.':
    'Odpowiedz na pytanie, aby AMY mogła napisać posty.',
  'AMY writes the plan with your answer.': 'AMY pisze plan z uwzględnieniem Twojej odpowiedzi.',
  'Plan “{name}”': 'Zaplanuj „{name}”',
  'Plan ready: {n} posts for “{name}”.': 'Plan gotowy: postów {n} do „{name}”.',
  'The plan for “{name}” is ready: {n} posts. Review it and activate the campaign when it looks right.':
    'Plan „{name}” jest gotowy: postów {n}. Sprawdź go i aktywuj kampanię, gdy będzie w porządku.',
  '{name}: plan ready for review': '{name}: plan do sprawdzenia',
  '{n} versions ready for {day}.': 'Gotowe wersje: {n} na {day}.',
  'Not made for {channels}: reconnect the account or free a slot, then ask again.':
    'Nie przygotowano dla: {channels}. Połącz konto lub zwolnij miejsce i poproś ponownie.',
  'You are welcome! Tell me whenever you want me to prepare something.':
    'Proszę bardzo! Daj znać, gdy mam coś przygotować.',
  'Noted. If you want me to make a post or ideas from this, just say so.':
    'Zanotowane. Jeśli chcesz, żebym zrobiła z tego post lub pomysły, po prostu powiedz.',
  'Thanks for the idea! I am turning it into a draft.': 'Dzięki za pomysł! Zamieniam go w szkic.',
  'A {channel} post about “{title}”{when}.': 'Post na {channel} o „{title}”{when}.',
  '{channels} post about “{title}”{when}{campaign}.':
    'Post ({channels}) o „{title}”{when}{campaign}.',
  'New ideas for “{name}”.': 'Nowe pomysły do „{name}”.',
  'AMY suggests ideas; you choose which go into the calendar.':
    'AMY proponuje pomysły; Ty wybierasz, które trafią do kalendarza.',
  'AMY drafts it in the first free slot, then asks you to review.':
    'AMY przygotuje szkic w pierwszym wolnym miejscu i poprosi o sprawdzenie.',
  'AMY drafts one version per channel, then asks you to review.':
    'AMY przygotuje po jednej wersji na kanał i poprosi o sprawdzenie.',
  'Hakusana will pick this up and reply in this conversation.':
    'Hakusana zajmie się tym i odpowie w tej rozmowie.',
  '{name} answered AMY: {text}': '{name} odpowiada AMY: {text}',
  '{name} handed a task to Hakusana: {text}': '{name} przekazuje zadanie Hakusanie: {text}',
  '{name} paused content creation for “{title}”. Scheduled posts still publish.':
    '{name} wstrzymuje tworzenie treści dla „{title}”. Zaplanowane posty nadal zostaną opublikowane.',
  '{name} resumed content creation for “{title}”.':
    '{name} wznawia tworzenie treści dla „{title}”.',
  '{name} paused publishing for “{title}”. Scheduled posts are held.':
    '{name} wstrzymuje publikowanie dla „{title}”. Zaplanowane posty są wstrzymane.',
  '{name} resumed publishing for “{title}”.': '{name} wznawia publikowanie dla „{title}”.',
  'AMY drafted {n} sample posts for “{title}”. Approve them and AMY drafts the rest in batches.':
    'AMY przygotowała próbne posty ({n}) do „{title}”. Zatwierdź je, a AMY przygotuje resztę w partiach.',
  'Samples approved. AMY drafted the next {n} posts for “{title}” automatically.':
    'Próbki zatwierdzone. AMY automatycznie przygotowała kolejne posty ({n}) do „{title}”.',
  'AMY drafted the next {n} posts for “{title}”.':
    'AMY przygotowała kolejne posty ({n}) do „{title}”.',
  'Held: campaign publishing paused': 'Wstrzymano: publikowanie kampanii wstrzymane',
  'Publishing resumed': 'Publikowanie wznowione',
  'Sample post from the campaign plan': 'Próbny post z planu kampanii',
  'Drafted in an automatic batch': 'Przygotowano w automatycznej partii',
  'Drafted from {name}’s request': 'Przygotowano na prośbę: {name}',
  '{channel} is no longer one of this campaign’s channels. Add it back in Edit, or decline the idea.':
    '{channel} nie jest już kanałem tej kampanii. Dodaj go z powrotem w Edycji albo odrzuć pomysł.',
  '{channel} is no longer in this campaign.': '{channel} nie należy już do tej kampanii.',
  'This is the chat for “{name}”. Ask me anything about the campaign here.':
    'To jest czat kampanii „{name}”. Pytaj mnie tutaj o wszystko, co jej dotyczy.',
  'Cancelled when its campaign ended. It will not be published.':
    'Anulowano po zakończeniu kampanii. Nie zostanie opublikowany.',
  'Moved “{title}” to {when}.': 'Przeniesiono „{title}” na {when}.',
  'Moved “{title}”. Its approval is kept.': 'Przeniesiono „{title}”. Zatwierdzenie pozostaje.',
  'Move undone': 'Cofnięto przeniesienie',
  Undo: 'Cofnij',
  'Tip: drag a post to a free slot on the same channel to move it.':
    'Wskazówka: przeciągnij post na wolne miejsce w tym samym kanale, aby go przenieść.',
  'Selected posts': 'Zaznaczone posty',
  '{n} selected': 'Zaznaczono: {n}',
  'Approved {n} posts. They are scheduled.': 'Zatwierdzono posty: {n}. Są zaplanowane.',
  'Approve {n}': 'Zatwierdź ({n})',
  'Only {name} can approve': 'Tylko {name} może zatwierdzać',
  'Review one by one': 'Sprawdzaj po kolei',
  Clear: 'Wyczyść',
  'Select all {n} waiting for review': 'Zaznacz wszystkie do sprawdzenia ({n})',
  'Select {post}': 'Zaznacz {post}',
  'Preview as on {channel}': 'Podgląd jak na {channel}',
  'Original sound': 'Oryginalny dźwięk',
  'Company page · now': 'Strona firmowa · teraz',
  'Just now · public': 'Przed chwilą · publiczny',
  Like: 'Lubię to',
  Repost: 'Udostępnij dalej',
  Share: 'Udostępnij',
  'Too long for {channel}: {n} of {max} characters.': 'Za długi dla {channel}: {n} z {max} znaków.',
  '{n} characters · {channel} shows about {fold} before “more”. Simplified preview.':
    'Znaków: {n} · {channel} pokazuje około {fold} przed „więcej”. Uproszczony podgląd.',
  Post: 'Post',
  'As on {channel}': 'Jak na {channel}',
  'Move to another day': 'Przenieś na inny dzień',
  Move: 'Przenieś',
  'Choose a new time': 'Wybierz nowy termin',
  'Published to {account}.': 'Opublikowano na {account}.',
  '{account} is still not connected.': '{account} nadal nie jest połączone.',
  'Publish now': 'Opublikuj teraz',
  'Invite sent at {time}': 'Zaproszenie wysłano o {time}',
  'Invite sent to {name} (simulated)': 'Wysłano zaproszenie do: {name} (symulacja)',
  '{name} connected the account (simulated). You can publish now.':
    '{name} połączył konto (symulacja). Możesz teraz opublikować.',
  'Simulate: connected': 'Symuluj: połączono',
  'Moved to {when} at {time}.': 'Przeniesiono na {when}, {time}.',
  'Move “{title}”': 'Przenieś „{title}”',
  'now {when} at {time}': 'teraz {when}, {time}',
  'One post per channel per day. Days with a post on {channel} are taken.':
    'Jeden post na kanał dziennie. Dni z postem na {channel} są zajęte.',
  'Taken by “{title}”': 'Zajęte przez „{title}”',
  Current: 'Obecny',
  Free: 'Wolne',
  Time: 'Godzina',
  'Only the time changes. The post still needs your review.':
    'Zmienia się tylko termin. Post nadal czeka na sprawdzenie.',
  'Move to {when}': 'Przenieś na {when}',
  less: 'mniej',
  'That slot was just taken. Choose another day.':
    'To miejsce właśnie zostało zajęte. Wybierz inny dzień.',
  'Choose a day after today.': 'Wybierz dzień po dzisiejszym.',
  'This post can no longer be moved.': 'Tego posta nie można już przenieść.',
  'That slot is taken. One post per channel per day.':
    'To miejsce jest zajęte. Jeden post na kanał dziennie.',
  'The approval is kept, and the post is scheduled again at the new time.':
    'Zatwierdzenie pozostaje, a post jest ponownie zaplanowany na nowy termin.',
  'The approval is kept. Only the time changes.':
    'Zatwierdzenie pozostaje. Zmienia się tylko termin.',
  'Moved from {from} to {to}': 'Przeniesiono z {from} na {to}',
  '{name} moved “{title}” ({channel}) from {from} to {to}.':
    '{name} przenosi „{title}” ({channel}) z {from} na {to}.',
  'Published again to {account}': 'Opublikowano ponownie na {account}',
  '“{title}” is now published to {account} too.':
    '„{title}” jest teraz opublikowany także na {account}.',
  '{asked} was already full on {full}, so AMY used the next free day: {where}. Use Move on a draft to change it.':
    '{asked} był już zajęty na {full}, więc AMY użyła najbliższego wolnego dnia: {where}. Użyj Przenieś przy szkicu, aby to zmienić.',
  'Drafts ready: {where}.': 'Szkice gotowe: {where}.',
  '{day} is already full on {channels}. AMY uses the next free day there, or pick another date.':
    '{day} jest już zajęty na {channels}. AMY użyje tam najbliższego wolnego dnia albo wybierz inną datę.',
  'New post': 'Nowy post',
  Day: 'Dzień',
  Title: 'Tytuł',
  Save: 'Zapisz',
  taken: 'zajęte',
  'Edit {word}': 'Edytuj {word}',
  'Add a post to the plan': 'Dodaj post do planu',
  'This queue is done': 'Ta kolejka jest gotowa',
  '{n} other posts in {ws} are still waiting for review.':
    'W {ws} na sprawdzenie czeka jeszcze postów: {n}.',
  'Review the other {n}': 'Sprawdź pozostałe ({n})',
  '{day} is already full on {channels}. AMY uses up to three days before, or pick another date.':
    '{day} jest już zajęty na {channels}. AMY użyje do trzech dni wcześniej albo wybierz inną datę.',
  'New time suggested by the client': 'Klient proponuje nowy termin',
  'Checking result': 'Sprawdzanie wyniku',
  'New time suggested': 'Zaproponowano nowy termin',
  'Approve these {n} versions?': 'Zatwierdzić te wersje ({n})?',
  '{network} needs reconnecting: approved, but it waits until reconnected':
    '{network} wymaga ponownego połączenia: zatwierdzony, ale poczeka do połączenia',
  'Not included': 'Nieuwzględnione',
  'No longer waiting for review ({status})': 'Już nie czeka na sprawdzenie ({status})',
  'You skipped {n} in this queue. They still need a decision.':
    'Pominięto w tej kolejce: {n}. Nadal czekają na decyzję.',
  'Back to the {n} you skipped': 'Wróć do pominiętych ({n})',
  '{name} suggests {when} at {time}': '{name} proponuje {when}, {time}',
  'New time applied.': 'Nowy termin zastosowany.',
  'That slot is taken now. Choose another time with Move.':
    'To miejsce jest już zajęte. Wybierz inny termin przez Przenieś.',
  Apply: 'Zastosuj',
  'Kept the current time.': 'Pozostawiono obecny termin.',
  'Keep current time': 'Zostaw obecny termin',
  'Suggestion withdrawn.': 'Propozycja wycofana.',
  Withdraw: 'Wycofaj',
  'Skip for now': 'Pomiń na razie',
  'Nothing is needed from you.': 'Nic nie musisz robić.',
  'One account needs its owner to connect it. The others are done and will not be posted again.':
    'Jedno konto musi połączyć jego właściciel. Pozostałe są gotowe i nie zostaną opublikowane ponownie.',
  'AMY is confirming one result. You do not need to do anything.':
    'AMY potwierdza jeden wynik. Nie musisz nic robić.',
  'Open published post: not available in the demo':
    'Otwórz opublikowany post: niedostępne w wersji demo',
  'Checked: it was published. Nothing was posted twice.':
    'Sprawdzono: post został opublikowany. Nic nie opublikowano dwa razy.',
  'Check result': 'Sprawdź wynik',
  'Suggestion sent. Hakusana confirms the new time; until then the post keeps its current time.':
    'Propozycja wysłana. Hakusana potwierdzi nowy termin; do tego czasu post zachowa obecny termin.',
  'Note for Hakusana (optional)': 'Wiadomość dla Hakusany (opcjonalnie)',
  'For example: the tasting moved to Friday': 'Na przykład: degustacja przeniesiona na piątek',
  'Your agency moves posts. They get your suggestion and confirm it; the post keeps its current time until then.':
    'Posty przenosi Twoja agencja. Otrzyma propozycję i ją potwierdzi; do tego czasu post zachowa obecny termin.',
  'Suggest a new time': 'Zaproponuj nowy termin',
  'Suggest a new time for “{title}”': 'Zaproponuj nowy termin dla „{title}”',
  'Suggest {when}': 'Zaproponuj {when}',
  'Apply it, or keep the current time.': 'Zastosuj albo zostaw obecny termin.',
  'Waiting for Hakusana to confirm. The post keeps its current time until then.':
    'Czeka na potwierdzenie Hakusany. Do tego czasu post zachowa obecny termin.',
  'Almost done': 'Prawie gotowe',
  '{asked} was already full on {full}, so AMY used an earlier free day: {where}. Use Move on a draft to change it.':
    '{asked} był już zajęty na {full}, więc AMY użyła wcześniejszego wolnego dnia: {where}. Użyj Przenieś przy szkicu, aby to zmienić.',
  'Not made for {channels}: no free slot on or up to three days before {asked}. Free a slot, then ask again.':
    'Nie przygotowano dla {channels}: brak wolnego miejsca w dniu {asked} ani do trzech dni wcześniej. Zwolnij miejsce i poproś ponownie.',
  'No free {channel} slot on {asked} or the three days before. Free a slot and press Retry.':
    'Brak wolnego miejsca na {channel} w dniu {asked} ani trzy dni wcześniej. Zwolnij miejsce i kliknij Ponów.',
  'Suggested a new time: {when}': 'Zaproponowano nowy termin: {when}',
  '{name} suggested moving “{title}” ({channel}) to {when}. Hakusana will confirm.':
    '{name} proponuje przeniesienie „{title}” ({channel}) na {when}. Hakusana potwierdzi.',
  'Declined the suggested time': 'Odrzucono proponowany termin',
  '{name} kept “{title}” at its current time.': '{name} zostawia „{title}” w obecnym terminie.',
  'Checked {account}: it was published, nothing was posted twice':
    'Sprawdzono {account}: opublikowano, nic nie powtórzono',
  'Instagram did not confirm in time. AMY checks whether it went out before trying again.':
    'Instagram nie potwierdził na czas. AMY sprawdza, czy post został opublikowany, zanim spróbuje ponownie.',
  '{day} is already full on {channels}.': '{day} jest już zajęty na {channels}.',
  earlier: 'wcześniej',
  'next free {day}, after the date': 'najbliższy wolny {day}, po dacie',
  'no free day soon': 'brak wolnego dnia w najbliższym czasie',
  'OK to post after the date where needed': 'Można publikować po dacie, jeśli trzeba',
  'Without this, AMY asks you before posting anything after the date.':
    'Bez tego AMY zapyta Cię, zanim opublikuje cokolwiek po dacie.',
  '{asked} and the three days before are full on {channels}. Next free: {next}. Post then, or only on the channels that fit?':
    '{asked} i trzy dni wcześniej są zajęte na {channels}. Najbliższe wolne: {next}. Publikować wtedy, czy tylko na kanałach, które się mieszczą?',
  'Use the next free days': 'Użyj najbliższych wolnych dni',
  'Only the channels that fit': 'Tylko kanały, które się mieszczą',
  'Choose below, or pick another date with Add an idea.':
    'Wybierz poniżej albo wskaż inną datę przez Dodaj pomysł.',
  '{asked} is full on {channels}. Should I use the next free day ({next}) or skip those channels?':
    '{asked} jest zajęty na {channels}. Mam użyć najbliższego wolnego dnia ({next}) czy pominąć te kanały?',
  'As you chose, {full} goes out after {asked}: {where}. Use Move on a draft to change it.':
    'Zgodnie z Twoim wyborem {full} wyjdzie po {asked}: {where}. Użyj Przenieś przy szkicu, aby to zmienić.',
  'AMY drafts it with your choice.': 'AMY przygotuje szkic zgodnie z Twoim wyborem.',
  '{name} chose the next free days for “{title}”.':
    '{name} wybiera najbliższe wolne dni dla „{title}”.',
  '{name} chose only the channels that fit for “{title}”.':
    '{name} wybiera tylko pasujące kanały dla „{title}”.',
  'Needs a new time': 'Wymaga nowego terminu',
  'Pause all publishing for {ws}?': 'Wstrzymać całe publikowanie dla {ws}?',
  'Nothing is published until you resume. Drafts and reviews continue. Demo clock: {time} today.':
    'Nic nie zostanie opublikowane do wznowienia. Szkice i sprawdzanie trwają dalej. Zegar demo: dziś {time}.',
  '{n} scheduled posts would wait': 'Zaplanowane posty, które poczekają: {n}',
  'Do not publish late': 'Nie publikuj z opóźnieniem',
  '…and {n} more': '…i jeszcze {n}',
  'After resuming, posts missed by up to two hours go out late, unless marked Do not publish late. Anything later needs a new time.':
    'Po wznowieniu posty spóźnione do dwóch godzin zostaną opublikowane z opóźnieniem, chyba że oznaczono je „Nie publikuj z opóźnieniem”. Późniejsze wymagają nowego terminu.',
  'Resume time (demo clock; the pause started at {time})':
    'Godzina wznowienia (zegar demo; wstrzymano o {time})',
  'Nothing was missed during the pause.': 'W czasie wstrzymania nic nie zostało pominięte.',
  'Missed during the pause': 'Pominięte w czasie wstrzymania',
  'Goes out now, {m} minutes late': 'Wychodzi teraz, z opóźnieniem {m} min',
  'Marked Do not publish late: needs a new time':
    'Oznaczono „Nie publikuj z opóźnieniem”: wymaga nowego terminu',
  'More than two hours late: needs a new time':
    'Ponad dwie godziny opóźnienia: wymaga nowego terminu',
  'Publishing resumed. {n} posts need a new time.':
    'Publikowanie wznowione. Postów wymagających nowego terminu: {n}.',
  'Publishing resumed.': 'Publikowanie wznowione.',
  'Resume at {time}': 'Wznów o {time}',
  '{title}, slide {i} of {n}': '{title}, slajd {i} z {n}',
  'Version history ({n})': 'Historia wersji ({n})',
  'Version {n} · current': 'Wersja {n} · bieżąca',
  'Change: {note}': 'Zmiana: {note}',
  'Different photo': 'Inne zdjęcie',
  'Its time passed and it was not published. Choose or suggest a new time; nothing is rebooked automatically.':
    'Jego termin minął i nie został opublikowany. Wybierz lub zaproponuj nowy termin; nic nie jest planowane ponownie automatycznie.',
  'Approved after its time; moved to the next free slot: {when}':
    'Zatwierdzono po terminie; przeniesiono na najbliższe wolne miejsce: {when}',
  'Approved after its time; no free slot, needs a new time':
    'Zatwierdzono po terminie; brak wolnego miejsca, wymaga nowego terminu',
  '{name} approved “{title}” after its time. It moved to {when}.':
    '{name} zatwierdza „{title}” po terminie. Przeniesiono na {when}.',
  '{name} approved “{title}” after its time. It needs a new time.':
    '{name} zatwierdza „{title}” po terminie. Wymaga nowego terminu.',
  'Published {m} minutes late after the pause': 'Opublikowano z opóźnieniem {m} min po wstrzymaniu',
  'Missed during the pause; marked do not publish late':
    'Pominięto w czasie wstrzymania; oznaczono „nie publikuj z opóźnieniem”',
  'Missed during the pause by more than two hours':
    'Pominięto w czasie wstrzymania o ponad dwie godziny',
  '{name} resumed publishing at {time}.': '{name} wznawia publikowanie o {time}.',
  'AMY is still drafting it. Review it when the draft is ready.':
    'AMY nadal przygotowuje szkic. Sprawdź go, gdy będzie gotowy.',
  'It needs material first, so there is nothing to approve yet.':
    'Najpierw potrzebne są materiały, więc nie ma jeszcze czego zatwierdzić.',
  '{channel} already has a post on {day}. Choose another day.':
    '{channel} ma już post w dniu {day}. Wybierz inny dzień.',
  '{n} planned posts clash with the calendar. Edit their day before activating.':
    'Zaplanowane posty kolidujące z kalendarzem: {n}. Zmień ich dzień przed aktywacją.',
  '{n} planned posts for “{title}” clash with posts already in the calendar. Edit their day in the plan.':
    'Zaplanowane posty „{title}” kolidujące z kalendarzem: {n}. Zmień ich dzień w planie.',
  'All statuses': 'Wszystkie statusy',
  'All accounts': 'Wszystkie konta',
  'Clear filters': 'Wyczyść filtry',
  'Showing {n} posts that match': 'Pasujące posty: {n}',
  'Current day · change the time': 'Obecny dzień · zmień godzinę',
  'Moved. It was on {when} at {time}.': 'Przeniesiono. Wcześniej: {when}, {time}.',
  'The original slot is taken now.': 'Pierwotne miejsce jest już zajęte.',
  'Waiting for confirmation': 'Czeka na potwierdzenie',
  'Connected now. You can publish to this account.': 'Połączono. Możesz opublikować na tym koncie.',
  'The owner approves posts, stops posts and manages people and accounts.':
    'Właściciel zatwierdza i zatrzymuje posty oraz zarządza ludźmi i kontami.',
  'Toggle post approvals for {name}': 'Przełącz zatwierdzanie postów dla: {name}',
  'Toggle stopping posts for {name}': 'Przełącz zatrzymywanie postów dla: {name}',
  '{name} no longer has access.': '{name} nie ma już dostępu.',
  'Remove access': 'Usuń dostęp',
  Invitations: 'Zaproszenia',
  'Invitation expired · sent {when} by {name}':
    'Zaproszenie wygasło · wysłane {when} przez: {name}',
  'Invited {when} by {name} · expires in 7 days':
    'Zaproszono {when} (zaprasza: {name}) · wygasa za 7 dni',
  'Invitation sent again to {email} (simulated)':
    'Zaproszenie wysłane ponownie do {email} (symulacja)',
  Resend: 'Wyślij ponownie',
  'Invitation withdrawn': 'Zaproszenie wycofane',
  '{name} accepted the invitation (simulated)': '{name} przyjmuje zaproszenie (symulacja)',
  'Simulate: accepted': 'Symuluj: przyjęto',
  'Who can do what': 'Kto co może',
  Person: 'Osoba',
  'Review and comment': 'Sprawdzanie i komentarze',
  Approve: 'Zatwierdzanie',
  'Stop scheduled posts': 'Zatrzymywanie zaplanowanych',
  'Move posts': 'Przenoszenie postów',
  'People and accounts': 'Ludzie i konta',
  'Suggests a time': 'Proponuje termin',
  'Accounts only': 'Tylko konta',
  'Clients approve their own posts. The agency prepares, moves and stops posts, and helps with accounts.':
    'Klienci zatwierdzają swoje posty. Agencja przygotowuje, przenosi i zatrzymuje posty oraz pomaga z kontami.',
  'Your own choices for {ws}. Others in the workspace choose theirs.':
    'Twoje ustawienia dla {ws}. Inni w obszarze roboczym wybierają własne.',
  When: 'Kiedy',
  'Always shown in the app': 'Zawsze widoczne w aplikacji',
  '{event} by {channel}': '{event}: {channel}',
  'Quiet hours: no phone notifications 21:00–07:00, except problems with posts going out today':
    'Godziny ciszy: bez powiadomień na telefon 21:00–07:00, poza problemami z dzisiejszymi postami',
  'Your agency': 'Twoja agencja',
  'Your main contact': 'Twój główny kontakt',
  'Usually replies within one working day': 'Zwykle odpowiada w ciągu jednego dnia roboczego',
  'No main contact is assigned yet.': 'Nie przypisano jeszcze głównego kontaktu.',
  'Staff assigned to {ws}': 'Zespół przypisany do {ws}',
  'Agency only. Assigned staff see this workspace and its tasks; the main contact is shown to the client.':
    'Tylko dla agencji. Przypisany zespół widzi ten obszar i jego zadania; główny kontakt jest widoczny dla klienta.',
  'Main contact': 'Główny kontakt',
  'Make main contact': 'Ustaw jako główny kontakt',
  '{email} already has access or a pending invitation.':
    '{email} ma już dostęp lub oczekujące zaproszenie.',
  'Invitation sent to {email} (simulated). It expires in 7 days.':
    'Zaproszenie wysłane do {email} (symulacja). Wygasa za 7 dni.',
  'Full name': 'Imię i nazwisko',
  'What can they do?': 'Co może robić?',
  'Review posts, comment and request changes': 'Sprawdzać posty, komentować i prosić o zmiany',
  'Approve posts for publishing': 'Zatwierdzać posty do publikacji',
  'They get an email with a link that works for 7 days. You can change these permissions later.':
    'Otrzyma e-mail z linkiem ważnym 7 dni. Uprawnienia możesz później zmienić.',
  'Connected by': 'Połączone przez',
  'Connected on': 'Połączono',
  'Access expires': 'Dostęp wygasa',
  'Upcoming posts on this account ({n})': 'Nadchodzące posty na tym koncie ({n})',
  'Nothing planned for this account.': 'Na tym koncie nic nie zaplanowano.',
  'Access expired. Only {name} can reconnect, because the network asks the account owner to log in.':
    'Dostęp wygasł. Połączyć ponownie może tylko {name}, bo serwis wymaga logowania właściciela konta.',
  'A personal profile can only be connected by its owner, {name}. Send them an invitation to connect.':
    'Profil osobisty może połączyć tylko jego właściciel: {name}. Wyślij zaproszenie do połączenia.',
  'Not connected. Connect it to publish here.': 'Niepołączone. Połącz, aby tu publikować.',
  'AMY publishes only what you approve. It never posts in your name without an approved post.':
    'AMY publikuje tylko to, co zatwierdzisz. Nigdy nie publikuje w Twoim imieniu bez zatwierdzonego posta.',
  '{n} upcoming posts on this account keep their approval but wait until it is connected again. Nothing is deleted.':
    'Nadchodzące posty na tym koncie ({n}) zachowają zatwierdzenie, ale poczekają na ponowne połączenie. Nic nie zostanie usunięte.',
  '{account} disconnected. {n} scheduled posts wait.':
    'Odłączono {account}. Czekające zaplanowane posty: {n}.',
  'A personal LinkedIn is connected by its owner. Invite them from Settings › People, or use Invite to connect on the profile.':
    'Osobisty LinkedIn łączy jego właściciel. Zaproś go w Ustawienia › Ludzie albo użyj Zaproś do połączenia przy profilu.',
  'Posts ready for review': 'Posty do sprawdzenia',
  'When AMY has a draft or a new version for you.': 'Gdy AMY ma dla Ciebie szkic lub nową wersję.',
  'Requested changes are ready': 'Prośby o zmiany są gotowe',
  'When a version you asked to change comes back.': 'Gdy wraca wersja, w której prosiłeś o zmiany.',
  'When a post goes out.': 'Gdy post zostanie opublikowany.',
  'Something needs you': 'Coś wymaga Twojej uwagi',
  'A failed or partial publication, missing material or a question from AMY.':
    'Nieudana lub częściowa publikacja, brak materiałów albo pytanie od AMY.',
  'Connection problems': 'Problemy z połączeniem',
  'An account needs reconnecting.': 'Konto wymaga ponownego połączenia.',
  'Weekly summary': 'Podsumowanie tygodnia',
  'Monday morning: what went out and what is planned.':
    'W poniedziałek rano: co wyszło i co jest zaplanowane.',
  'In the app': 'W aplikacji',
  Phone: 'Telefon',
  'Account manager': 'Opiekun klienta',
  'Content specialist': 'Specjalista ds. treści',
  Designer: 'Projektant',
  Expired: 'Wygasło',
  Invited: 'Zaproszono',
  '{name} invited {person} as a contributor.': '{name} zaprasza {person} jako współpracownika.',
  '{name} removed {person} from the workspace.': '{name} usuwa {person} z obszaru roboczego.',
  '{name} disconnected {account} ({network}). {n} scheduled posts wait until it is connected again.':
    '{name} odłącza {account} ({network}). Zaplanowane posty ({n}) poczekają na ponowne połączenie.',
  'Approved post needs a new time': 'Zatwierdzony post wymaga nowego terminu',
  'No posts match these filters': 'Żaden post nie pasuje do filtrów',
  'Other posts this week are hidden by the filters.':
    'Pozostałe posty z tego tygodnia są ukryte przez filtry.',
  'Taken · hidden by filters': 'Zajęte · ukryte przez filtry',
  'The account is connected now. Publish it there; the others will not be posted again.':
    'Konto jest już połączone. Opublikuj tam post; na pozostałych kontach nie zostanie opublikowany ponownie.',
  '1 + 1 Reel/Story': '1 + 1 Reel/Story',
  '1–{d} November': '1–{d} listopada',
  'A personal LinkedIn profile belongs to one person, so only they can connect it. Choose who; they get a link that does nothing except connect their profile to {ws}.':
    'Osobisty profil LinkedIn należy do jednej osoby, więc tylko ona może go połączyć. Wybierz kogo; dostanie link, który służy wyłącznie do połączenia profilu z {ws}.',
  'AI connected. AMY can draft with {provider} now.':
    'AI połączone. AMY może teraz tworzyć szkice z {provider}.',
  'AI connection': 'Połączenie z AI',
  'AI is connected for {ws}. {owner} has been told. You can close this page.':
    'AI jest połączone dla {ws}. {owner} dostał(a) powiadomienie. Możesz zamknąć tę stronę.',
  'AI key removed. AMY stops drafting until a key is connected.':
    'Klucz AI usunięty. AMY nie tworzy szkiców, dopóki nie połączysz klucza.',
  'AI tasks (drafts and revisions)': 'Zadania AI (szkice i poprawki)',
  'AMY cannot read private messages or change your password.':
    'AMY nie może czytać prywatnych wiadomości ani zmieniać hasła.',
  'AMY checks the key straight away and tells you what to do if something is missing.':
    'AMY od razu sprawdza klucz i mówi, co zrobić, jeśli czegoś brakuje.',
  'AMY drafts the first posts for {date}; you review them before anything is scheduled.':
    'AMY przygotuje pierwsze posty na {date}; sprawdzisz je, zanim cokolwiek zostanie zaplanowane.',
  'AMY made {n} sample posts with your brand kit. Approve them or ask for changes; this shows AMY what you like.':
    'AMY przygotowała {n} przykładowe posty według Twojego brand kitu. Zatwierdź je lub poproś o zmiany – tak AMY pozna Twój gust.',
  'AMY needs your own AI key to draft posts. Your provider bills you separately from AMY.':
    'AMY potrzebuje Twojego klucza AI, żeby tworzyć szkice. Dostawca rozlicza Cię osobno od AMY.',
  'AMY only states facts from here, for example opening hours in a post. The brand kit links to these details instead of keeping its own copy.':
    'AMY podaje w postach tylko fakty stąd, na przykład godziny otwarcia. Brand kit korzysta z tych danych zamiast trzymać własną kopię.',
  'AMY stops drafting new posts and revisions. Scheduled and approved posts still publish. You can connect a key again at any time.':
    'AMY przestanie tworzyć nowe posty i poprawki. Zaplanowane i zatwierdzone posty nadal się opublikują. Klucz możesz połączyć ponownie w każdej chwili.',
  'Accounts you manage on {network}:': 'Konta, którymi zarządzasz w {network}:',
  'Activate the plan': 'Aktywuj plan',
  'Activated on {date}.': 'Aktywowano {date}.',
  'Activated on {date}': 'Aktywowano {date}',
  'Add a payment method at {provider}, then test again. Nothing else needs changing.':
    'Dodaj metodę płatności w {provider} i przetestuj ponownie. Nic więcej nie trzeba zmieniać.',
  'All set': 'Wszystko gotowe',
  Allow: 'Zezwól',
  'Allow AMY to use your {network} account?': 'Zezwolić AMY na korzystanie z konta {network}?',
  'Already connected to {ws}': 'Już połączone z {ws}',
  'An API key lets AMY use your own AI account. Your AI provider bills you separately from AMY.':
    'Klucz API pozwala AMY korzystać z Twojego konta AI. Dostawca AI rozlicza Cię osobno od AMY.',
  'Audience, products, opening hours and contacts live in one place, Business details, so they are never out of step.':
    'Odbiorcy, produkty, godziny otwarcia i kontakty są w jednym miejscu – w danych firmy – więc zawsze są zgodne.',
  'Back to the owner’s view': 'Wróć do widoku właściciela',
  'Before you can activate': 'Zanim aktywujesz',
  'Brand kit': 'Brand kit',
  'Business details saved. AMY uses them in new drafts.':
    'Dane firmy zapisane. AMY użyje ich w nowych szkicach.',
  Cadence: 'Częstotliwość',
  'Can edit brand drafts': 'Może edytować wersję roboczą marki',
  'Can publish': 'Może publikować',
  'Choose a person': 'Wybierz osobę',
  'Choose account': 'Wybierz konto',
  'Choose another model above and test again.': 'Wybierz inny model powyżej i przetestuj ponownie.',
  Closed: 'Zamknięte',
  'Closing time must be after opening time.': 'Godzina zamknięcia musi być po godzinie otwarcia.',
  Connect: 'Połącz',
  'Connect AI for {ws}': 'Połącz AI dla {ws}',
  'Connect AI so AMY can draft.': 'Połącz AI, żeby AMY mogła tworzyć szkice.',
  'Connect an account': 'Połącz konto',
  'Connect another account': 'Połącz kolejne konto',
  'Connect at least one social account.': 'Połącz co najmniej jedno konto społecznościowe.',
  'Connect to workspace {ws}': 'Połącz z przestrzenią {ws}',
  'Connect-only invitation sent to {name} (simulated)':
    'Wysłano zaproszenie tylko do połączenia do: {name} (symulacja)',
  'Connected by {name} · last test {when}': 'Połączył(a) {name} · ostatni test {when}',
  'Connected to {provider} ({model}) by {name}. Last test {when}.':
    'Połączono z {provider} ({model}) – {name}. Ostatni test {when}.',
  Copy: 'Kopiuj',
  'Create a new key': 'Utwórz nowy klucz',
  'Daily digest email at 08:00 instead of one email per post':
    'Codzienne podsumowanie e-mailem o 08:00 zamiast osobnego e-maila dla każdego posta',
  Date: 'Data',
  'Date, e.g. 31 Dec': 'Data, np. 31 gru',
  'Dates, not a balance: each date can be used once per channel, and only on that date.':
    'To daty, a nie saldo: każdą datę można wykorzystać raz na kanał i tylko w tym dniu.',
  'Demo outcome of the test': 'Wynik testu w wersji demo',
  'Demo: do not paste a real key. Nothing leaves this browser. A real setup checks the key with {provider}.':
    'Demo: nie wklejaj prawdziwego klucza. Nic nie opuszcza tej przeglądarki. W prawdziwej konfiguracji klucz sprawdza {provider}.',
  'Discard changes': 'Odrzuć zmiany',
  'Each channel can publish one post per day. Unused days do not carry over, so a quiet week never means extra posts today. Extra slots for a format, such as a Story, are set by Hakusana; none are set for this workspace.':
    'Każdy kanał może opublikować jeden post dziennie. Niewykorzystane dni nie przechodzą dalej, więc spokojny tydzień nie oznacza dziś dodatkowych postów. Dodatkowe miejsca na format, np. Story, ustawia Hakusana; w tej przestrzeni nie ma żadnych.',
  'Each permission is separate: approving posts does not include stopping them or publishing a new brand version. Clients approve their own posts; the agency prepares, moves and stops posts, and helps with accounts.':
    'Każde uprawnienie jest osobne: zatwierdzanie postów nie obejmuje ich wstrzymywania ani publikowania nowej wersji marki. Klienci zatwierdzają swoje posty; agencja je przygotowuje, przenosi i wstrzymuje oraz pomaga z kontami.',
  'Edit brand drafts': 'Edycja wersji roboczej marki',
  'Edit business details': 'Edytuj dane firmy',
  'Estimate for 30 posts a month: about 90 AI requests (a draft and two revisions each) of around 2,000 tokens, so roughly 180,000 tokens. On a mid-size model that is usually under US$3 a month. Images and video are not included. Prices checked {date}; your provider’s bill shows the real amount.':
    'Szacunek dla 30 postów miesięcznie: około 90 zapytań do AI (szkic i dwie poprawki na post) po około 2000 tokenów, czyli ok. 180 000 tokenów. Na średnim modelu to zwykle poniżej 3 USD miesięcznie. Obrazy i wideo nie są wliczone. Ceny sprawdzone {date}; rzeczywistą kwotę pokazuje rachunek od dostawcy.',
  'Estimated cost': 'Szacowany koszt',
  'Every step is done. You can open any of them again from the list.':
    'Wszystkie kroki są gotowe. Każdy możesz ponownie otworzyć z listy.',
  'Exception date': 'Data wyjątku',
  'Exceptions (holidays, events, closures)': 'Wyjątki (święta, wydarzenia, zamknięcia)',
  'Finish setting up · {n} of {total} done': 'Dokończ konfigurację · {n} z {total} gotowe',
  'First batch': 'Pierwsza partia',
  'Fix the highlighted fields first.': 'Najpierw popraw zaznaczone pola.',
  'For {ws}': 'Dla {ws}',
  'Future days free': 'Wolne przyszłe dni',
  'Future days reserved': 'Zarezerwowane przyszłe dni',
  'Helper view · demo': 'Widok pomocnika · demo',
  'Hi {name}, {owner} uses AMY to prepare social media posts. Please connect their AI account: the link opens one short step with instructions. You will not see their posts or settings.':
    'Cześć {name}, {owner} przygotowuje posty w AMY. Połącz proszę konto AI: link otwiera jeden krótki krok z instrukcją. Nie zobaczysz postów ani ustawień.',
  'How this is estimated: tokens times the provider’s example list price for this model (US$ {pin} per million tokens in, US$ {pout} out, checked 3 Nov 2026). Providers bill in US dollars; your provider’s invoice is the real amount.':
    'Jak to liczymy: tokeny razy przykładowa cena katalogowa dostawcy dla tego modelu ({pin} USD za milion tokenów wejściowych, {pout} USD za wyjściowe, sprawdzone 3 listopada 2026). Dostawcy rozliczają się w dolarach; rzeczywistą kwotę pokazuje faktura dostawcy.',
  Illustration: 'Ilustracja',
  'Illustration of a key page': 'Ilustracja strony z kluczem',
  'Image and video rendering and storage are part of your AMY plan and are not on this list or on your AI bill.':
    'Renderowanie obrazów i wideo oraz przechowywanie są częścią planu AMY i nie ma ich na tej liście ani na rachunku za AI.',
  'Interface language': 'Język interfejsu',
  'Invitation preview': 'Podgląd zaproszenia',
  'Invitation sent to {email} (simulated)': 'Zaproszenie wysłane na {email} (symulacja)',
  'Invitation sent to {email} at {when}. You can carry on with the other steps.':
    'Zaproszenie wysłane na {email} o {when}. Możesz kontynuować pozostałe kroki.',
  'Invite a helper to connect AI': 'Zaproś pomocnika do połączenia AI',
  'It may be incomplete or deleted. Create a new key named AMY, copy it in full, and test again.':
    'Może być niepełny albo usunięty. Utwórz nowy klucz o nazwie AMY, skopiuj go w całości i przetestuj ponownie.',
  Key: 'Klucz',
  'Last 7 days': 'Ostatnie 7 dni',
  'Last updated by {name} on {date}': 'Ostatnio zmienił(a) {name}, {date}',
  'Manage in Settings': 'Zarządzaj w Ustawieniach',
  Model: 'Model',
  'No AI account is connected yet, so there is no usage to show. It appears here after you connect AI.':
    'Nie połączono jeszcze konta AI, więc nie ma danych o zużyciu. Pojawią się tu po połączeniu AI.',
  'No AI connected': 'Brak połączonego AI',
  'No exceptions yet.': 'Brak wyjątków.',
  'No slot left on this day': 'Brak wolnego miejsca w tym dniu',
  'November at a glance': 'Listopad w skrócie',
  'Only {name} can connect AI.': 'Tylko {name} może połączyć AI.',
  'Only {name} manages the AI key. Keys are never shown to anyone, including the agency.':
    'Kluczem AI zarządza tylko {name}. Klucze nigdy nie są nikomu pokazywane, także agencji.',
  'Open Materials': 'Otwórz Materiały',
  'Open the AI step for {ws} and connect a key. Nothing else: no posts, people or other settings.':
    'Otworzyć krok AI dla {ws} i połączyć klucz. Nic więcej: bez postów, osób i innych ustawień.',
  'Open the brand kit': 'Otwórz brand kit',
  'Open their link (demo)': 'Otwórz ich link (demo)',
  'Opening hours': 'Godziny otwarcia',
  'Past days not used': 'Niewykorzystane minione dni',
  'Paste a key first': 'Najpierw wklej klucz',
  'Paste the key here': 'Wklej tu klucz',
  Period: 'Okres',
  'Personal LinkedIn profiles are optional and connected by their owner; they do not block setup.':
    'Osobiste profile LinkedIn są opcjonalne i łączy je ich właściciel; nie blokują konfiguracji.',
  'Personal profile · connected by its owner': 'Profil osobisty · łączy go właściciel',
  'Plan activated. AMY drafts the first batch for your review.':
    'Plan aktywowany. AMY przygotowuje pierwszą partię do Twojej akceptacji.',
  'Posting time zone for {ws}': 'Strefa czasowa publikacji dla {ws}',
  'Posts go out at this local time. It does not change when someone views the calendar from another time zone.':
    'Posty wychodzą o tej godzinie lokalnej. Nie zmienia się ona, gdy ktoś ogląda kalendarz z innej strefy czasowej.',
  'Posts keep their own content language.': 'Posty zachowują własny język treści.',
  'Posts still go out at the workspace time: {zone}.':
    'Posty nadal wychodzą według czasu przestrzeni: {zone}.',
  'Products and offers': 'Produkty i oferta',
  'Publish posts you approve in AMY': 'Publikować posty zatwierdzone w AMY',
  'Published days': 'Dni z publikacją',
  'Read basic results such as reach and likes':
    'Odczytywać podstawowe wyniki, np. zasięg i polubienia',
  'Reconnect {account}': 'Połącz ponownie {account}',
  'Remove key': 'Usuń klucz',
  'Remove the AI key?': 'Usunąć klucz AI?',
  'Replace with another account': 'Zamień na inne konto',
  'Review the sample posts first.': 'Najpierw sprawdź przykładowe posty.',
  'Review the samples': 'Sprawdź przykłady',
  'Save business details': 'Zapisz dane firmy',
  Sections: 'Sekcje',
  'Send connect invitation': 'Wyślij zaproszenie do połączenia',
  'Setup progress': 'Postęp konfiguracji',
  'Show times in': 'Pokazuj godziny w',
  'Shown the same way in the sidebar, Settings, setup and the calendar.':
    'Tak samo widać to w menu bocznym, Ustawieniach, konfiguracji i kalendarzu.',
  'Simulated {network} screen': 'Symulowany ekran {network}',
  'Skipped for now': 'Pominięte na razie',
  'Skipped steps stay on the list and are not marked done.':
    'Pominięte kroki zostają na liście i nie są oznaczane jako gotowe.',
  Steps: 'Kroki',
  Task: 'Zadanie',
  'Test again': 'Przetestuj ponownie',
  'Test passed. AI is working.': 'Test zaliczony. AI działa.',
  'Thank you, {name}': 'Dziękujemy, {name}',
  'The account connected before': 'Konto połączone wcześniej',
  'The key field is empty. Use the demo key, or paste the key you created.':
    'Pole klucza jest puste. Użyj klucza demo albo wklej utworzony klucz.',
  'The key works, but billing is not set up': 'Klucz działa, ale płatności nie są skonfigurowane',
  'The last test did not pass. Replace the key or test again.':
    'Ostatni test nie przeszedł. Zamień klucz albo przetestuj ponownie.',
  'These apply to you only, not to the workspace.': 'Dotyczą tylko Ciebie, nie całej przestrzeni.',
  'This is a different account from {old}. {n} upcoming {network} posts would publish to {new} instead.':
    'To inne konto niż {old}. Nadchodzące posty w {network} ({n}) opublikują się zamiast tego na {new}.',
  'This is usually temporary. Your key is fine; try again in a minute.':
    'Zwykle to chwilowe. Klucz jest w porządku; spróbuj za minutę.',
  'This model is not available on your account': 'Ten model nie jest dostępny na Twoim koncie',
  'To do · {time}': 'Do zrobienia · {time}',
  'Toggle brand drafts for {name}': 'Przełącz edycję marki dla: {name}',
  'Tokens in / out': 'Tokeny wej. / wyj.',
  'Try again': 'Spróbuj ponownie',
  'Up to one post per channel per day; about {n} a week from the always-on plan':
    'Maksymalnie jeden post na kanał dziennie; około {n} tygodniowo z planu stałego',
  'Use a demo key': 'Użyj klucza demo',
  'Version {v}': 'Wersja {v}',
  'Waiting for someone else': 'Czeka na inną osobę',
  'Waiting for {name} to connect AI': 'Czekamy, aż {name} połączy AI',
  'What changes, e.g. open 10–14': 'Co się zmienia, np. otwarte 10–14',
  'What it might cost': 'Ile to może kosztować',
  'What they can do': 'Co ta osoba może zrobić',
  'Who you want to reach': 'Do kogo chcesz dotrzeć',
  'Workspace time ({zone})': 'Czas przestrzeni ({zone})',
  'Your brand kit is version {v}, approved by {name}. AMY writes and designs with it.':
    'Twój brand kit to wersja {v}, zatwierdzona przez: {name}. AMY pisze i projektuje według niego.',
  'Your preferences': 'Twoje preferencje',
  'expired {date}': 'wygasło {date}',
  'from Business details': 'z danych firmy',
  'key ending {k}': 'klucz kończący się na {k}',
  'not every account published; still reserved until retried or cancelled':
    'nie wszystkie konta opublikowały; miejsce zarezerwowane do ponowienia lub anulowania',
  optional: 'opcjonalnie',
  tokens: 'tokenów',
  '{account} is connected': '{account} jest połączone',
  '{account} is connected to {ws}.': '{account} jest połączone z {ws}.',
  '{day} closes': '{day} – zamknięcie',
  '{day} opens': '{day} – otwarcie',
  '{list} not connected yet, left out until connected':
    '{list} jeszcze niepołączone – pominięte do czasu połączenia',
  '{name} can change the brand kit draft and business details. Publishing a new brand version stays with the owner.':
    '{name} może zmieniać wersję roboczą brand kitu i dane firmy. Publikacja nowej wersji marki zostaje u właściciela.',
  '{name} can view the brand kit but not change it.':
    '{name} widzi brand kit, ale nie może go zmieniać.',
  '{name} completed the AI connection at {when}.': '{name} połączył(a) AI o {when}.',
  '{n} days with a free slot in the next two weeks':
    'Dni z wolnym miejscem w ciągu dwóch tygodni: {n}',
  '{n} of {cap} slots available on this day': 'Wolne miejsca w tym dniu: {n} z {cap}',
  '{n} photos and videos are in Materials. AMY picks from them; add more any time.':
    'W Materiałach są zdjęcia i filmy: {n}. AMY z nich wybiera; dodawaj kolejne w dowolnej chwili.',
  '{n} upcoming {network} posts use this channel, the next on {date}.':
    'Nadchodzące posty w {network} na tym kanale: {n}, najbliższy {date}.',
  '{owner} asked you to connect AI for {ws}': '{owner} prosi Cię o połączenie AI dla {ws}',
  '{owner} asked you to do this one step. You will not see their posts, people or settings.':
    '{owner} prosi Cię o ten jeden krok. Nie zobaczysz postów, osób ani ustawień.',
  '{provider} did not accept this key': '{provider} nie zaakceptował tego klucza',
  '{provider} did not answer': '{provider} nie odpowiada',
  '{provider} · {model}. AMY drafts with this account from now on.':
    '{provider} · {model}. Od teraz AMY tworzy szkice z tego konta.',
  '{ws} · {n} of {total} done. Do the steps in any order.':
    '{ws} · {n} z {total} gotowe. Kroki możesz robić w dowolnej kolejności.',
  '{x}: skipped for now. It stays on this list.': '{x}: pominięte na razie. Zostaje na liście.',
  Network: 'Sieć',
  'Allow access': 'Zezwól na dostęp',
  Confirm: 'Potwierdź',
  'Instagram business or creator account': 'Konto firmowe lub twórcy na Instagramie',
  'Personal Instagram accounts cannot publish through AMY.':
    'Osobiste konta Instagram nie mogą publikować przez AMY.',
  'A Page you manage. Personal Facebook profiles are not supported.':
    'Strona, którą zarządzasz. Osobiste profile Facebook nie są obsługiwane.',
  'TikTok account': 'Konto TikTok',
  'Video only.': 'Tylko wideo.',
  'A page where you are an admin.': 'Strona, na której jesteś administratorem.',
  'Someone’s personal LinkedIn profile': 'Czyjś osobisty profil LinkedIn',
  'Only that person can connect it. AMY sends them a connect-only invitation.':
    'Tylko ta osoba może go połączyć. AMY wyśle jej zaproszenie tylko do połączenia.',
  'Personal account. Switch it to a business or creator account in Instagram first.':
    'Konto osobiste. Najpierw zmień je na konto firmowe lub twórcy w Instagramie.',
  'Mid-size model (example)': 'Model średni (przykład)',
  'Small model (example)': 'Model mały (przykład)',
  'Large model (example)': 'Model duży (przykład)',
  Works: 'Działa',
  'Invalid key': 'Nieprawidłowy klucz',
  'Billing needed': 'Wymagane płatności',
  'Model unavailable': 'Model niedostępny',
  'Temporary failure': 'Chwilowy błąd',
  'Testing…': 'Testowanie…',
  'Test failed': 'Test nieudany',
  Revision: 'Poprawka',
  'Updated by {name} on {date}': 'Zaktualizował(a) {name}, {date}',
  'Brand kit version {v}': 'Brand kit w wersji {v}',
  '{n} items in Materials': 'Pozycje w Materiałach: {n}',
  'Waiting for {name}': 'Czeka na: {name}',
  '{n} of {total} need attention': 'Wymaga uwagi: {n} z {total}',
  '{total} accounts connected': 'Połączone konta: {total}',
  '{n} of {total} reviewed': 'Sprawdzone: {n} z {total}',
  '5–10 min': '5–10 min',
  '5 min': '5 min',
  'Business name': 'Nazwa firmy',
  Address: 'Adres',
  'Shown in posts that mention where to find you.':
    'Pokazywany w postach, które mówią, gdzie nas znaleźć.',
  'Public phone': 'Telefon publiczny',
  'Public email': 'E-mail publiczny',
  Website: 'Strona internetowa',
  'Menu or price list link': 'Link do menu lub cennika',
  'Optional. AMY links to it instead of copying prices.':
    'Opcjonalnie. AMY podaje link zamiast przepisywać ceny.',
  'Add the address guests should use.': 'Dodaj adres, którego mają używać goście.',
  'Check the email address.': 'Sprawdź adres e-mail.',
  'Check the phone number.': 'Sprawdź numer telefonu.',
  'Use a full link starting with https://': 'Użyj pełnego linku zaczynającego się od https://',
  'Replace key': 'Zamień klucz',
  'Replace account': 'Zamień konto',
  'They keep their approval and publish on time.': 'Zachowują akceptację i opublikują się na czas.',
  'They publish to this account once approved.': 'Opublikują się na tym koncie po akceptacji.',
  People: 'Osoby',
  '{network} is not connected': '{network} nie jest połączony',
  'Connect {network}': 'Połącz {network}',
  'Enter a full email address, like name@example.com.':
    'Wpisz pełny adres e-mail, np. imie@example.com.',
  '{ws} has no main contact now. Choose one below; until then the client sees “No main contact”.':
    '{ws} nie ma teraz głównego kontaktu. Wybierz go poniżej; do tego czasu klient widzi „Brak głównego kontaktu”.',
  '{name}’s own choices for {ws}. Others in the workspace choose theirs.':
    'Własne ustawienia: {name} w {ws}. Pozostałe osoby wybierają swoje.',
  'Show fewer': 'Pokaż mniej',
  'Show all {n} tasks': 'Pokaż wszystkie zadania ({n})',
  'How this is estimated: each task’s tokens times the example list price of the model it used, per million tokens in / out: small US$ 0.10 / 0.40, mid-size US$ 0.40 / 1.60, large US$ 2 / 8 (checked 3 Nov 2026). Providers bill in US dollars; your provider’s invoice is the real amount.':
    'Jak to liczymy: tokeny każdego zadania razy przykładowa cena katalogowa modelu, którego użyło, za milion tokenów wej. / wyj.: mały 0,10 / 0,40 USD, średni 0,40 / 1,60 USD, duży 2 / 8 USD (sprawdzone 3 listopada 2026). Dostawcy rozliczają się w dolarach; rzeczywistą kwotę pokazuje faktura dostawcy.',
  'Saved automatically. {name} reviews and applies it.':
    'Zapisano automatycznie. {name} sprawdza i zatwierdza zmiany.',
  'Times in {tz}; posts go out at {posting} time':
    'Godziny w strefie {tz}; posty wychodzą według czasu {posting}',
  '{account} is connected. {n} posts moved to it and need approval again.':
    '{account} jest połączone. Przeniesione posty ({n}) wymagają ponownej akceptacji.',
  'This is you, so you can connect your own profile now.':
    'To Ty, więc możesz od razu połączyć swój profil.',
  'Connect my own profile': 'Połącz mój profil',
  'Connect my profile': 'Połącz mój profil',
  'Replace {old} with {new}': 'Zamień {old} na {new}',
  '{n} upcoming posts move to {new}.': 'Nadchodzące posty ({n}) zostaną przeniesione na {new}.',
  '{n} of them were approved for {old}; they go back to review, so nothing is published to the new account without approval.':
    'Zatwierdzone dla {old}: {n}. Wracają do akceptacji, więc nic nie zostanie opublikowane na nowym koncie bez zgody.',
  'Until then AMY drafts on Hakusana’s trial allowance, which is not billed to you.':
    'Do tego czasu AMY tworzy szkice w ramach próbnego limitu Hakusany, za który nie płacisz.',
  'goes out at {time} {zone}': 'wychodzi o {time} {zone}',
  'Waiting for AI': 'Czeka na AI',
  'The AI key was removed, so AMY cannot make version {n} yet. Your request is saved and continues as soon as AI is connected again.':
    'Klucz AI został usunięty, więc AMY nie może jeszcze przygotować wersji {n}. Prośba jest zapisana i zostanie wykonana, gdy AI będzie znów połączone.',
  'Invitation sent {when}': 'Zaproszenie wysłane {when}',
  'No AI account of yours is connected yet. AMY drafts on Hakusana’s trial allowance, which is not billed to you and not listed here. Your usage appears after you connect AI.':
    'Nie połączono jeszcze Twojego konta AI. AMY tworzy szkice w ramach próbnego limitu Hakusany – nie płacisz za to i nie ma tego na liście. Twoje zużycie pojawi się po połączeniu AI.',
  'No AI account is connected, so AMY is not drafting and there is no usage to show.':
    'Nie ma połączonego konta AI, więc AMY nie tworzy szkiców i nie ma zużycia do pokazania.',
  'AMY drafts on Hakusana’s trial allowance until you connect your own AI key. Your provider then bills you separately from AMY.':
    'AMY tworzy szkice w ramach próbnego limitu Hakusany, dopóki nie połączysz własnego klucza AI. Potem dostawca rozlicza Cię osobno od AMY.',
  'AMY is not drafting: connect an AI key to continue. Requested changes wait until then.':
    'AMY nie tworzy szkiców: połącz klucz AI, aby kontynuować. Prośby o zmiany czekają do tego czasu.',
  'Waiting for an AI connection before making the new version':
    'Czeka na połączenie z AI przed przygotowaniem nowej wersji',
  'Account changed from {from} to {to}; needs approval again':
    'Zmieniono konto z {from} na {to}; wymaga ponownej akceptacji',
  'Connect {account}': 'Połącz {account}',
  'Got it. I have saved this as a task. AI is not connected right now, so I will start as soon as it is.':
    'Jasne, zapisałam to jako zadanie. AI nie jest teraz połączone, więc zacznę, gdy tylko będzie.',
  'Thanks for the idea! It is saved. AI is not connected right now, so I will draft it as soon as it is.':
    'Dzięki za pomysł! Jest zapisany. AI nie jest teraz połączone, więc przygotuję szkic, gdy tylko będzie.',
  'goes out {when} at {time} {zone}': 'wychodzi {when} o {time} {zone}',
  'Past days awaiting a result': 'Minione dni czekające na wynik',
  'Reserved from today': 'Zarezerwowane od dziś',
  'Free from today': 'Wolne od dziś',
  'Only {name} can reconnect this account': 'Tylko {name} może ponownie połączyć to konto',
  'Only {name} can connect accounts': 'Tylko {name} może łączyć konta',
  'Invitation sent again to {name} (simulated)':
    'Zaproszenie wysłane ponownie do: {name} (symulacja)',
  'Current model: {model}': 'Obecny model: {model}',
  'AI tasks in this period (drafts and revisions)': 'Zadania AI w tym okresie (szkice i poprawki)',
  'Tokens in this period': 'Tokeny w tym okresie',
  'Estimated cost in this period (US$)': 'Szacowany koszt w tym okresie (USD)',
  'Daily publishing limits': 'Dzienne limity publikacji',
  'Effective value = the workspace override if one is set, otherwise the agency default, never more than the platform maximum. It is what {ws} sees in its calendar and Plan allowance.':
    'Wartość obowiązująca = nadpisanie dla przestrzeni, jeśli jest ustawione, w przeciwnym razie domyślna wartość agencji, nigdy więcej niż maksimum platformy. Tę wartość {ws} widzi w kalendarzu i limicie planu.',
  'Platform maximum': 'Maksimum platformy',
  'Agency default (Hakusana)': 'Domyślnie w agencji (Hakusana)',
  'Not connected: nothing can be published until it is':
    'Niepołączone: nic nie zostanie opublikowane, dopóki nie zostanie połączone',
  'Set an override': 'Ustaw nadpisanie',
  'Unused days never carry over. Changes would apply to new bookings; scheduled posts are kept.':
    'Niewykorzystane dni nie przechodzą dalej. Zmiany dotyczyłyby nowych rezerwacji; zaplanowane posty zostają.',
  'Set a workspace override': 'Ustawianie nadpisania dla przestrzeni',
  'Hakusana workspaces': 'Przestrzenie Hakusany',
  'View limits': 'Pokaż limity',
  '…and {n} more workspaces that are not part of this demo.':
    '…i jeszcze {n} przestrzeni, których nie ma w tym demo.',
  'Message from the client': 'Wiadomość od klienta',
  Reply: 'Odpowiedz',
  'Reply to {name}': 'Odpowiedz: {name}',
  'Your reply': 'Twoja odpowiedź',
  'For example: Yes, I have added three posts for your Christmas hours. Please review them.':
    'Na przykład: Tak, dodałam trzy posty o świątecznych godzinach. Sprawdź je proszę.',
  '{name} sees your reply in AMY and gets a notification.':
    '{name} zobaczy odpowiedź w AMY i dostanie powiadomienie.',
  'Reply sent to {name}.': 'Odpowiedź wysłana do: {name}.',
  'Send reply': 'Wyślij odpowiedź',
  'Your messages': 'Twoje wiadomości',
  'You wrote at {time}': 'Napisano o {time}',
  '{name} from Hakusana replied at {time}': '{name} z Hakusany odpowiedział(a) o {time}',
  'Waiting for a reply': 'Czeka na odpowiedź',
  '{name} wrote to Hakusana: {text}': '{name} napisał(a) do Hakusany: {text}',
  '{name} (Hakusana) replied: {text}': '{name} (Hakusana) odpowiada: {text}',
  '{name} from Hakusana replied to your message':
    '{name} z Hakusany odpowiedział(a) na Twoją wiadomość',
  'Answer for the client': 'Odpowiedz w imieniu klienta',
  'Or finish it yourself': 'Albo dokończ to sam(a)',
  'What you did': 'Co zostało zrobione',
  'For example: I called Anna and added the posts to the calendar.':
    'Na przykład: Zadzwoniłam do Anny i dodałam posty do kalendarza.',
  'Mark as done': 'Oznacz jako gotowe',
  'Task done. The client sees your note.': 'Zadanie gotowe. Klient zobaczy Twoją notatkę.',
  '{name} (Hakusana) finished this: {note}': '{name} (Hakusana) zakończył(a): {note}',
  '{name} (Hakusana) finished “{title}”: {note}':
    '{name} (Hakusana) zakończył(a) „{title}”: {note}',
  'set by the platform': 'ustawione przez platformę',
  '{ws}: {channel} is now {value}. The client sees it in Plan allowance.':
    '{ws}: {channel} ma teraz {value}. Klient widzi to w limicie planu.',
  'from the override': 'z nadpisania',
  '{channel} is back to the agency default.': '{channel} wraca do domyślnej wartości agencji.',
  'Remove override': 'Usuń nadpisanie',
  'Override the limit for {ws}': 'Nadpisz limit dla {ws}',
  'Posts per day': 'Postów dziennie',
  '0 (channel paused)': '0 (kanał wstrzymany)',
  'Up to the platform maximum of {n}.': 'Maksymalnie {n} (limit platformy).',
  'Result: {channel} goes from {from} to {to} for {ws}. Changes apply to new bookings; scheduled posts are kept.':
    'Wynik: {channel} zmienia się z {from} na {to} dla {ws}. Zmiany dotyczą nowych rezerwacji; zaplanowane posty zostają.',
  'Prototype note: the new limit shows in the workspace’s Plan allowance and daily allowance. The calendar’s booking rules stay one post per channel per day until the backend applies limits.':
    'Uwaga dot. prototypu: nowy limit widać w limicie planu i dziennym limicie przestrzeni. Kalendarz nadal rezerwuje jeden post na kanał dziennie, dopóki backend nie zacznie stosować limitów.',
  'Save override': 'Zapisz nadpisanie',
  'A caption you like': 'Podpis, który Ci się podoba',
  'AMY made a new set with your feedback.': 'AMY przygotowała nowy zestaw z Twoimi uwagami.',
  'AMY read {url} (simulated in this demo). It found: {found}. You can check everything on the next cards.':
    'AMY przeczytała {url} (symulacja w demo). Znalazła: {found}. Wszystko sprawdzisz na kolejnych kartach.',
  'AMY will use it for every new post. Your first post is waiting for your review; nothing is scheduled until you approve it.':
    'AMY użyje go w każdym nowym poście. Twój pierwszy post czeka na akceptację; nic nie zostanie zaplanowane bez Twojej zgody.',
  'Add another profile': 'Dodaj kolejny profil',
  'Add more photos to Materials.': 'Dodaj więcej zdjęć do Materiałów.',
  'Add opening hours and contact details.': 'Dodaj godziny otwarcia i dane kontaktowe.',
  'Back to the samples': 'Wróć do przykładów',
  Business: 'Firma',
  Captions: 'Podpisy',
  'Change colour {n}': 'Zmień kolor {n}',
  'Closest to your tone': 'Najbliżej Twojego tonu',
  'Connect a social profile before anything can be scheduled.':
    'Połącz profil społecznościowy, zanim cokolwiek zostanie zaplanowane.',
  'Connect a {channel} profile first. Then you can approve and schedule this post.':
    'Najpierw połącz profil {channel}. Potem możesz zatwierdzić i zaplanować ten post.',
  'Connect your own AI account. Until then AMY drafts on Hakusana’s trial allowance.':
    'Połącz własne konto AI. Do tego czasu AMY korzysta z próbnego limitu Hakusany.',
  'Continue getting started': 'Kontynuuj pierwsze kroki',
  'Demo: use a sample logo': 'Demo: użyj przykładowego logo',
  'Demo: use {url}': 'Demo: użyj {url}',
  'First post': 'Pierwszy post',
  'From Google Drive or a shared folder': 'Z Dysku Google lub udostępnionego folderu',
  'From my phone or computer': 'Z telefonu lub komputera',
  'From your website': 'Z Twojej strony',
  'Getting started: a few questions, then three sample posts in your style':
    'Pierwsze kroki: kilka pytań, potem trzy przykładowe posty w Twoim stylu',
  'Google Drive (simulated): choose a photo': 'Dysk Google (symulacja): wybierz zdjęcie',
  'In your own words': 'Własnymi słowami',
  'In your own words, e.g. “It looks warm and shows our real shop”':
    'Własnymi słowami, np. „Jest ciepło i widać nasz prawdziwy lokal”',
  'Is there anything I should avoid saying? (optional)':
    'Czy jest coś, czego mam nie pisać? (opcjonalnie)',
  'Let AMY choose': 'Niech AMY wybierze',
  'Let me decide after seeing the samples': 'Zdecyduję po obejrzeniu przykładów',
  'Link to a post you like': 'Link do posta, który Ci się podoba',
  Logo: 'Logo',
  Look: 'Wygląd',
  'Make a new set': 'Przygotuj nowy zestaw',
  'Never say': 'Nigdy nie pisz',
  'New set with your feedback: “{text}”': 'Nowy zestaw z Twoimi uwagami: „{text}”',
  'No logo or website colours yet. Pick a colour you always use, or let AMY choose.':
    'Nie ma jeszcze kolorów z logo ani strony. Wybierz kolor, którego zawsze używasz, albo pozwól wybrać AMY.',
  'No {channel} profile connected yet': 'Nie połączono jeszcze profilu {channel}',
  'None of these': 'Żaden z tych',
  'Not set yet': 'Jeszcze nie ustawiono',
  'Open the setup checklist': 'Otwórz listę konfiguracji',
  'Or mix and match': 'Albo połącz elementy',
  'Paste a caption you like instead': 'Albo wklej podpis, który Ci się podoba',
  'Plan my first month': 'Zaplanuj mój pierwszy miesiąc',
  'Preview only: no profile connected yet.': 'Tylko podgląd: nie połączono jeszcze profilu.',
  'Preview samples without connecting': 'Zobacz przykłady bez łączenia',
  Progress: 'Postęp',
  'Question {n} of {total}': 'Pytanie {n} z {total}',
  'Read my website': 'Przeczytaj moją stronę',
  'Review my first post': 'Sprawdź mój pierwszy post',
  'Same story three ways, in {lang} for {channel}.':
    'Ta sama historia na trzy sposoby, {lang}, dla {channel}.',
  'Sample {look} look with sample {cap} captions, for {channel}':
    'Wygląd z przykładu {look}, podpisy z przykładu {cap}, dla {channel}',
  'Sample {n}': 'Przykład {n}',
  'Save and exit': 'Zapisz i wyjdź',
  'Save my style': 'Zapisz mój styl',
  'Saved. Continue any time from the calendar.':
    'Zapisano. Możesz wrócić w każdej chwili z kalendarza.',
  'Saving puts your first post in Needs your review. Nothing is scheduled until you approve it.':
    'Po zapisaniu pierwszy post trafi do akceptacji. Nic nie zostanie zaplanowane bez Twojej zgody.',
  'Still to do, whenever you are ready': 'Do zrobienia, kiedy zechcesz',
  'Style saved. Your first post is waiting for your review.':
    'Styl zapisany. Pierwszy post czeka na Twoją akceptację.',
  'Taken from your website. Edit anything that is not right.':
    'Pobrane z Twojej strony. Popraw, jeśli coś się nie zgadza.',
  'That’s it for now': 'Na razie wystarczy',
  Use: 'Użyj',
  'Use these': 'Użyj tych',
  'Use this caption style': 'Użyj tego stylu podpisów',
  'Use this look': 'Użyj tego wyglądu',
  'Use this sample': 'Użyj tego przykładu',
  'Website address': 'Adres strony',
  'What it is about': 'O czym jest post',
  'What would you like me to change?': 'Co mam zmienić?',
  'What your business does': 'Czym zajmuje się Twoja firma',
  'When is it?': 'Kiedy?',
  'When is it? e.g. Friday 27 Nov, 19:00': 'Kiedy? np. piątek 27 lis, 19:00',
  'Which one for the first sample posts?': 'Który do pierwszych przykładowych postów?',
  'You can preview and save your style first. A profile is needed before anything is scheduled.':
    'Możesz najpierw zobaczyć przykłady i zapisać styl. Profil jest potrzebny, zanim cokolwiek zostanie zaplanowane.',
  'You can review and change this post now. To approve and schedule it, connect a profile first.':
    'Możesz teraz sprawdzić i zmienić ten post. Aby go zatwierdzić i zaplanować, najpierw połącz profil.',
  'Your logo': 'Twoje logo',
  'Your style is saved': 'Twój styl jest zapisany',
  'a logo': 'logo',
  'a short description': 'krótki opis',
  'connect {channel} before it can be scheduled':
    'połącz {channel}, zanim post zostanie zaplanowany',
  'e.g. Kawiarnia Zielna': 'np. Kawiarnia Zielna',
  'e.g. We’re a café in Warsaw that roasts its own coffee.':
    'np. Jesteśmy kawiarnią w Warszawie, która sama pali kawę.',
  'e.g. less formal, no emoji, show the coffee closer':
    'np. mniej oficjalnie, bez emoji, kawa bliżej',
  'e.g. no prices, never “cheap”': 'np. bez cen, nigdy „tanio”',
  'e.g. www.yourbusiness.pl': 'np. www.twojafirma.pl',
  needed: 'wymagane',
  'only a name': 'tylko nazwę',
  'your name': 'nazwę',
  '{n} colours': 'kolory: {n}',
  'Start as a new client': 'Zacznij jako nowy klient',
  'Your business': 'Twoja firma',
  'Your style': 'Twój styl',
  'Your channels': 'Twoje kanały',
  'Sample posts': 'Przykładowe posty',
  'Does your business have a website?': 'Czy Twoja firma ma stronę internetową?',
  'I can read it and fill in what I find, so you only check it.':
    'Mogę ją przeczytać i uzupełnić, co znajdę – Ty tylko sprawdzasz.',
  'What should I call your business?': 'Jak mam nazywać Twoją firmę?',
  'What does your business do?': 'Czym zajmuje się Twoja firma?',
  'One or two sentences, as you would tell a new customer.':
    'Jedno lub dwa zdania, tak jak powiedział(a)byś nowemu klientowi.',
  'What language should I write your posts in?': 'W jakim języku mam pisać posty?',
  'Do you have a logo you’d like me to use?': 'Czy masz logo, którego mam używać?',
  'Which colours should I keep?': 'Które kolory mam zachować?',
  'Suggested from your logo or website. Tap a colour to change it.':
    'Zaproponowane na podstawie logo lub strony. Dotknij koloru, aby go zmienić.',
  'Can you show me a photo or post with a look you like?':
    'Pokażesz mi zdjęcie lub post, który Ci się podoba?',
  'A phone photo of your place is perfect.':
    'Zdjęcie Twojego lokalu z telefonu w zupełności wystarczy.',
  'What do you like about this look?': 'Co Ci się w tym podoba?',
  'Pick any that fit, or say it in your own words.':
    'Wybierz, co pasuje, albo napisz własnymi słowami.',
  'Which of these sounds most like your business?':
    'Który z tych tekstów najbardziej brzmi jak Twoja firma?',
  'Want to add another profile?': 'Dodać kolejny profil?',
  'You can add more later in Settings.': 'Kolejne możesz dodać później w Ustawieniach.',
  'Where would you like your first post to go?': 'Gdzie ma się ukazać Twój pierwszy post?',
  'Connect one profile now. You can add more later.':
    'Połącz teraz jeden profil. Kolejne możesz dodać później.',
  'What should your first post be about?': 'O czym ma być Twój pierwszy post?',
  'Which sample feels most like your business?':
    'Który przykład najbardziej pasuje do Twojej firmy?',
  'Here’s what AMY will remember': 'Oto co zapamięta AMY',
  'Edit anything before saving. You can change it later on the Brand page.':
    'Przed zapisaniem możesz wszystko poprawić. Później zmienisz to na stronie Marka.',
  'Warm light': 'Ciepłe światło',
  'Real people': 'Prawdziwi ludzie',
  'Close-ups': 'Zbliżenia',
  'Bright colours': 'Jasne kolory',
  'Calm and minimal': 'Spokojnie i minimalistycznie',
  'Natural, not posed': 'Naturalnie, bez pozowania',
  'Warm and personal': 'Ciepło i osobiście',
  'Clean and simple': 'Czysto i prosto',
  'Bright and playful': 'Jasno i z humorem',
  'Short and clear': 'Krótko i jasno',
  'Lively and playful': 'Żywo i z humorem',
  'A new product': 'Nowy produkt',
  'An event': 'Wydarzenie',
  'Introduce my business': 'Przedstaw moją firmę',
  Both: 'Oba',
  Keep: 'Zostaw',
  'Choose a different file': 'Wybierz inny plik',
  'Choose a file': 'Wybierz plik',
  'No website': 'Brak strony',
  'e.g. Live music on Friday evening': 'np. Muzyka na żywo w piątek wieczorem',
  'e.g. Our new apple cake': 'np. Nasza nowa szarlotka',
  'AMY chooses': 'Wybiera AMY',
  '{name} finished getting started. AMY saved the style and made the first post for review.':
    '{name} skończył(a) pierwsze kroki. AMY zapisała styl i przygotowała pierwszy post do akceptacji.',
  'Made from your setup choices': 'Przygotowano na podstawie Twoich wyborów',
  'Created during setup': 'Utworzono podczas pierwszych kroków',
  'Chosen during setup': 'Wybrano podczas pierwszych kroków',
  'Welcome to AMY! A few short questions and I will show you three sample posts in your style.':
    'Witaj w AMY! Kilka krótkich pytań i pokażę Ci trzy przykładowe posty w Twoim stylu.',
  'New client (demo)': 'Nowy klient (demo)',
  'No brand kit yet': 'Nie ma jeszcze brand kitu',
  'Answer a few questions in Getting started and AMY creates your brand kit from your logo, colours, a photo you like and your tone.':
    'Odpowiedz na kilka pytań w pierwszych krokach, a AMY utworzy brand kit z Twojego logo, kolorów, ulubionego zdjęcia i tonu.',
  'no profile yet': 'brak profilu',
};
